/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { useConfig } from '@/store';

import axios, { isAxiosError, AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

class Api  {
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private baseUrl = "";

    getWorkflowsPaginatedUrl(page: number | undefined, size: number | undefined, assigned: boolean | undefined, statuses: Statuses[] | undefined, ids: string[] | undefined, steps: Steps[] | undefined, client: string | undefined, description: string | undefined, supplier: string | undefined, vehicle: string | undefined, search: string | undefined): string {
        let url_ = this.baseUrl + "/api/v1/workflows?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (assigned === null)
            throw new globalThis.Error("The parameter 'assigned' cannot be null.");
        else if (assigned !== undefined)
            url_ += "assigned=" + encodeURIComponent("" + assigned) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (steps === null)
            throw new globalThis.Error("The parameter 'steps' cannot be null.");
        else if (steps !== undefined)
            steps && steps.forEach(item => { url_ += "steps=" + encodeURIComponent("" + item) + "&"; });
        if (client === null)
            throw new globalThis.Error("The parameter 'client' cannot be null.");
        else if (client !== undefined)
            url_ += "client=" + encodeURIComponent("" + client) + "&";
        if (description === null)
            throw new globalThis.Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (supplier === null)
            throw new globalThis.Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (vehicle === null)
            throw new globalThis.Error("The parameter 'vehicle' cannot be null.");
        else if (vehicle !== undefined)
            url_ += "vehicle=" + encodeURIComponent("" + vehicle) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param page (optional) 
     * @param size (optional) 
     * @param assigned (optional) Filters for order processes that are assigned to user calling endpoint
     * @param statuses (optional) Filter by workflow status
     * @param ids (optional) Collection of IDs (ExternalReference), filters for exact match, or for partial text search
     * @param steps (optional) Current process step on Quotation/PurchaseOrder/Delivery
     * @param client (optional) Full or partial client Id or client name
     * @param description (optional) Partial text search on quotation description (Finland workflows only)
     * @param supplier (optional) Partial text search on supplier ID or supplier name across all purchase orders
     * @param vehicle (optional) Partial text search on vehicle manufacturer, model, or trim
     * @param search (optional) Free-text search — matches partial ExternalReference OR (Finland) quotation description with OR semantics
     * @return OK
     */
     async getWorkflowsPaginated(page: number | undefined, size: number | undefined, assigned: boolean | undefined, statuses: Statuses[] | undefined, ids: string[] | undefined, steps: Steps[] | undefined, client: string | undefined, description: string | undefined, supplier: string | undefined, vehicle: string | undefined, search: string | undefined, requestConfig?: AxiosRequestConfig<PaginatedResponseDtoOfWorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<PaginatedResponseDtoOfWorkflowDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getWorkflowsPaginatedUrl(page, size, assigned, statuses, ids, steps, client, description, supplier, vehicle, search),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    getWorkflowdotsPaginatedUrl(page: number | undefined, size: number | undefined, assigned: boolean | undefined, statuses: Statuses2[] | undefined, ids: string[] | undefined, steps: Steps2[] | undefined, client: string | undefined, description: string | undefined, supplier: string | undefined, vehicle: string | undefined, search: string | undefined): string {
        let url_ = this.baseUrl + "/api/v1/workflows/flat?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (assigned === null)
            throw new globalThis.Error("The parameter 'assigned' cannot be null.");
        else if (assigned !== undefined)
            url_ += "assigned=" + encodeURIComponent("" + assigned) + "&";
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (steps === null)
            throw new globalThis.Error("The parameter 'steps' cannot be null.");
        else if (steps !== undefined)
            steps && steps.forEach(item => { url_ += "steps=" + encodeURIComponent("" + item) + "&"; });
        if (client === null)
            throw new globalThis.Error("The parameter 'client' cannot be null.");
        else if (client !== undefined)
            url_ += "client=" + encodeURIComponent("" + client) + "&";
        if (description === null)
            throw new globalThis.Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (supplier === null)
            throw new globalThis.Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (vehicle === null)
            throw new globalThis.Error("The parameter 'vehicle' cannot be null.");
        else if (vehicle !== undefined)
            url_ += "vehicle=" + encodeURIComponent("" + vehicle) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param page (optional) 
     * @param size (optional) 
     * @param assigned (optional) Filters for order processes that are assigned to user calling endpoint
     * @param statuses (optional) Filter by workflow status
     * @param ids (optional) Collection of IDs (ExternalReference), filters for exact match, or for partial text search
     * @param steps (optional) Current process step on Quotation/PurchaseOrder/Delivery
     * @param client (optional) Full or partial client Id or client name
     * @param description (optional) Partial text search on quotation description (Finland workflows only)
     * @param supplier (optional) Partial text search on supplier ID or supplier name across all purchase orders
     * @param vehicle (optional) Partial text search on vehicle manufacturer, model, or trim
     * @param search (optional) Free-text search — matches partial ExternalReference OR (Finland) quotation description with OR semantics
     * @return OK
     */
     async getWorkflowdotsPaginated(page: number | undefined, size: number | undefined, assigned: boolean | undefined, statuses: Statuses2[] | undefined, ids: string[] | undefined, steps: Steps2[] | undefined, client: string | undefined, description: string | undefined, supplier: string | undefined, vehicle: string | undefined, search: string | undefined, requestConfig?: AxiosRequestConfig<PaginatedResponseDtoOfWorkflowFlatDto> & AdditionalResponseConfiguration): Promise<ApiResult<PaginatedResponseDtoOfWorkflowFlatDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getWorkflowdotsPaginatedUrl(page, size, assigned, statuses, ids, steps, client, description, supplier, vehicle, search),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    getWorkflowUrl(id: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param if_None_Match (optional) Strong ETag token; when it matches the current workflow version the response returns 304 or waits for changes if timeout is above 0
     * @param x_Poll_Timeout (optional) Optional long-poll timeout in milliseconds
     * @return OK
     */
     async getWorkflow(id: string, if_None_Match: string | undefined, x_Poll_Timeout: number | undefined, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getWorkflowUrl(id),
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "X-Poll-Timeout": x_Poll_Timeout !== undefined && x_Poll_Timeout !== null ? "" + x_Poll_Timeout : "",
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    patchWorkflowUrl(id: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
     async patchWorkflow(id: string, body: Body[] | undefined, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: this.patchWorkflowUrl(id),
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    getWorkflowsDealerAddressUrl(id: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{id}/dealer-address";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async getWorkflowsDealerAddress(id: string, requestConfig?: AxiosRequestConfig<BusinessPartnerAddress> & AdditionalResponseConfiguration): Promise<ApiResult<BusinessPartnerAddress, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getWorkflowsDealerAddressUrl(id),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowQuotationCompletestepUrl(id: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{id}/quotation/complete-step";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async workflowQuotationCompletestep(id: string, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "POST",
            url: this.workflowQuotationCompletestepUrl(id),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowDeliveryCompletestepUrl(id: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{id}/delivery/complete-step";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async workflowDeliveryCompletestep(id: string, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "POST",
            url: this.workflowDeliveryCompletestepUrl(id),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowPurchaseorderCompletestepUrl(id: string, number: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{id}/purchase-orders/{number}/complete-step";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async workflowPurchaseorderCompletestep(id: string, number: string, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "POST",
            url: this.workflowPurchaseorderCompletestepUrl(id, number),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowQuotationRejectedUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/quotation/reject";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
     async workflowQuotationRejected(externalReference: string, body: RejectionReasonDto | null | undefined, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.workflowQuotationRejectedUrl(externalReference),
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowPurchaseorderRejectUrl(externalReference: string, number: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/purchase-orders/{number}/reject";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param body (optional) 
     * @return OK
     */
     async workflowPurchaseorderReject(externalReference: string, number: string, body: RejectionInitiatorDto | null | undefined, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.workflowPurchaseorderRejectUrl(externalReference, number),
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowQuotationGetApprovalFlowUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/quotation/approval-flow";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async workflowQuotationGetApprovalFlow(externalReference: string, requestConfig?: AxiosRequestConfig<ApprovalFlowDto> & AdditionalResponseConfiguration): Promise<ApiResult<ApprovalFlowDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.workflowQuotationGetApprovalFlowUrl(externalReference),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowQuotationUpdateApprovalFlowUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/quotation/approval-flow";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return Created
     */
     async workflowQuotationUpdateApprovalFlow(externalReference: string, body: ApprovalFlowDto, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: this.workflowQuotationUpdateApprovalFlowUrl(externalReference),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowSlugsResendUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/slugs/resend";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async workflowSlugsResend(externalReference: string, requestConfig?: AxiosRequestConfig<ResendResultDto> & AdditionalResponseConfiguration): Promise<ApiResult<ResendResultDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "POST",
            url: this.workflowSlugsResendUrl(externalReference),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowQuotationRestartUrl(id: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{id}/quotation/restart";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async workflowQuotationRestart(id: string, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "POST",
            url: this.workflowQuotationRestartUrl(id),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowPurchaseorderRestartUrl(id: string, number: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{id}/purchase-orders/{number}/restart";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async workflowPurchaseorderRestart(id: string, number: string, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "POST",
            url: this.workflowPurchaseorderRestartUrl(id, number),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    workflowParkingDecisionUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/unpark-decision";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async workflowParkingDecision(externalReference: string, body: UnparkDecisionDto, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.workflowParkingDecisionUrl(externalReference),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    orderParkingDecisionUrl(externalReference: string, number: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/purchase-orders/{number}/unpark-decision";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async orderParkingDecision(externalReference: string, number: string, body: UnparkOrderDecisionDto, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.orderParkingDecisionUrl(externalReference, number),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    getWorkflowContentManagerUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/content-manager/items";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async getWorkflowContentManager(externalReference: string, requestConfig?: AxiosRequestConfig<ItemDto[]> & AdditionalResponseConfiguration): Promise<ApiResult<ItemDto[], void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getWorkflowContentManagerUrl(externalReference),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    downloadWorkflowContentManagerUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/content-manager";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async downloadWorkflowContentManager(externalReference: string, body: DownloadContentManagerItemDto, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.downloadWorkflowContentManagerUrl(externalReference),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    clientDriversUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/client-drivers";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async clientDrivers(externalReference: string, requestConfig?: AxiosRequestConfig<PersonPartnerDto[]> & AdditionalResponseConfiguration): Promise<ApiResult<PersonPartnerDto[], void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.clientDriversUrl(externalReference),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    driverUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/driver";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async driver(externalReference: string, requestConfig?: AxiosRequestConfig<DriverDto> & AdditionalResponseConfiguration): Promise<ApiResult<DriverDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.driverUrl(externalReference),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    ssnUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/driver/ssn";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async ssn(externalReference: string, body: SsnDto, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: this.ssnUrl(externalReference),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    contactPersonUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/contact-person";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async contactPerson(externalReference: string, requestConfig?: AxiosRequestConfig<ContactPersonDto> & AdditionalResponseConfiguration): Promise<ApiResult<ContactPersonDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.contactPersonUrl(externalReference),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    costCenterUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/cost-center";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async costCenter(externalReference: string, requestConfig?: AxiosRequestConfig<CostCenterDto> & AdditionalResponseConfiguration): Promise<ApiResult<CostCenterDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.costCenterUrl(externalReference),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    dealerUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/dealer";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async dealer(externalReference: string, requestConfig?: AxiosRequestConfig<OrganizationPartnerDto> & AdditionalResponseConfiguration): Promise<ApiResult<OrganizationPartnerDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.dealerUrl(externalReference),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    supplierUrl(externalReference: string, number: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/purchase-orders/{number}/supplier";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async supplier(externalReference: string, number: string, requestConfig?: AxiosRequestConfig<SupplierPartnerDto> & AdditionalResponseConfiguration): Promise<ApiResult<SupplierPartnerDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.supplierUrl(externalReference, number),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    supplierSalespersonUrl(externalReference: string): string {
        let url_ = this.baseUrl + "/api/v1/workflows/{externalReference}/supplier-salesperson";
        if (externalReference === undefined || externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' must be defined.");
        url_ = url_.replace("{externalReference}", encodeURIComponent("" + externalReference));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async supplierSalesperson(externalReference: string, requestConfig?: AxiosRequestConfig<SupplierSalesPersonDto> & AdditionalResponseConfiguration): Promise<ApiResult<SupplierSalesPersonDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.supplierSalespersonUrl(externalReference),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    deliveryProtocolUrl(vin: string): string {
        let url_ = this.baseUrl + "/api/v1/deliveries/{vin}";
        if (vin === undefined || vin === null)
            throw new globalThis.Error("The parameter 'vin' must be defined.");
        url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async deliveryProtocol(vin: string, body: DeliveryProtocolDto, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: this.deliveryProtocolUrl(vin),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    sapDownloadListUrl(page: number | undefined, size: number | undefined, createdBefore: string | undefined, createdAfter: string | undefined, files: string[] | undefined): string {
        let url_ = this.baseUrl + "/api/v1/sap-download?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (createdBefore === null)
            throw new globalThis.Error("The parameter 'createdBefore' cannot be null.");
        else if (createdBefore !== undefined)
            url_ += "createdBefore=" + encodeURIComponent("" + createdBefore) + "&";
        if (createdAfter === null)
            throw new globalThis.Error("The parameter 'createdAfter' cannot be null.");
        else if (createdAfter !== undefined)
            url_ += "createdAfter=" + encodeURIComponent("" + createdAfter) + "&";
        if (files === null)
            throw new globalThis.Error("The parameter 'files' cannot be null.");
        else if (files !== undefined)
            files && files.forEach(item => { url_ += "files=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param page (optional) 
     * @param size (optional) 
     * @param createdBefore (optional) 
     * @param createdAfter (optional) 
     * @param files (optional) 
     * @return OK
     */
     async sapDownloadList(page: number | undefined, size: number | undefined, createdBefore: string | undefined, createdAfter: string | undefined, files: string[] | undefined, requestConfig?: AxiosRequestConfig<PaginatedResponseDtoOfSapFileInfoDto> & AdditionalResponseConfiguration): Promise<ApiResult<PaginatedResponseDtoOfSapFileInfoDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.sapDownloadListUrl(page, size, createdBefore, createdAfter, files),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    sapDownloadFileUrl(fileName: string): string {
        let url_ = this.baseUrl + "/api/v1/sap-download/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async sapDownloadFile(fileName: string, requestConfig?: AxiosRequestConfig<string> & AdditionalResponseConfiguration): Promise<ApiResult<string, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.sapDownloadFileUrl(fileName),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    sapDownloadZipUrl(createdBefore: string | undefined, createdAfter: string | undefined, files: string[] | undefined): string {
        let url_ = this.baseUrl + "/api/v1/sap-download/zip?";
        if (createdBefore === null)
            throw new globalThis.Error("The parameter 'createdBefore' cannot be null.");
        else if (createdBefore !== undefined)
            url_ += "createdBefore=" + encodeURIComponent("" + createdBefore) + "&";
        if (createdAfter === null)
            throw new globalThis.Error("The parameter 'createdAfter' cannot be null.");
        else if (createdAfter !== undefined)
            url_ += "createdAfter=" + encodeURIComponent("" + createdAfter) + "&";
        if (files === null)
            throw new globalThis.Error("The parameter 'files' cannot be null.");
        else if (files !== undefined)
            files && files.forEach(item => { url_ += "files=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param createdBefore (optional) 
     * @param createdAfter (optional) 
     * @param files (optional) 
     * @return OK
     */
     async sapDownloadZip(createdBefore: string | undefined, createdAfter: string | undefined, files: string[] | undefined, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.sapDownloadZipUrl(createdBefore, createdAfter, files),
            headers: {
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    sapDownloadValidateUrl(fileName: string): string {
        let url_ = this.baseUrl + "/api/v1/sap-download/validate/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async sapDownloadValidate(fileName: string, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "POST",
            url: this.sapDownloadValidateUrl(fileName),
            headers: {
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    organizationsUrl(search: string | undefined): string {
        let url_ = this.baseUrl + "/api/v1/user-management/organizations?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param search (optional) 
     * @return OK
     */
     async organizations(search: string | undefined, requestConfig?: AxiosRequestConfig<OrganizationDto[]> & AdditionalResponseConfiguration): Promise<ApiResult<OrganizationDto[], void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.organizationsUrl(search),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    groupsUrl(): string {
        let url_ = this.baseUrl + "/api/v1/user-management/groups";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async groups(requestConfig?: AxiosRequestConfig<GroupDto[]> & AdditionalResponseConfiguration): Promise<ApiResult<GroupDto[], void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.groupsUrl(),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    getEmployerPartnersUrl(): string {
        let url_ = this.baseUrl + "/api/v1/user-management/employer-partners";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async getEmployerPartners(requestConfig?: AxiosRequestConfig<EmployerPartnerDto[]> & AdditionalResponseConfiguration): Promise<ApiResult<EmployerPartnerDto[], void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getEmployerPartnersUrl(),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    userManagementUrl(): string {
        let url_ = this.baseUrl + "/api/v1/user-management";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async userManagement(body: CreateUserDto, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.userManagementUrl(),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    getBusinessPartnersUrl(page: number | undefined, size: number | undefined, search: string | undefined): string {
        let url_ = this.baseUrl + "/api/v1/business-partners?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param page (optional) 
     * @param size (optional) 
     * @param search (optional) 
     * @return OK
     */
     async getBusinessPartners(page: number | undefined, size: number | undefined, search: string | undefined, requestConfig?: AxiosRequestConfig<PaginatedResponseDtoOfBusinessPartner> & AdditionalResponseConfiguration): Promise<ApiResult<PaginatedResponseDtoOfBusinessPartner, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getBusinessPartnersUrl(page, size, search),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    getApprovalFlowUrl(id: string): string {
        let url_ = this.baseUrl + "/api/v1/business-partners/{id}/approval-flow";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async getApprovalFlow(id: string, requestConfig?: AxiosRequestConfig<ApprovalFlow> & AdditionalResponseConfiguration): Promise<ApiResult<ApprovalFlow, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getApprovalFlowUrl(id),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    updateApprovalFlowUrl(id: string): string {
        let url_ = this.baseUrl + "/api/v1/business-partners/{id}/approval-flow";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return Created
     */
     async updateApprovalFlow(id: string, body: ApprovalFlowDto, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: this.updateApprovalFlowUrl(id),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    getClientRegisteredEmployeesUrl(clientId: string): string {
        let url_ = this.baseUrl + "/api/v1/business-partners/{clientId}/client-registered-employees";
        if (clientId === undefined || clientId === null)
            throw new globalThis.Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async getClientRegisteredEmployees(clientId: string, requestConfig?: AxiosRequestConfig<User[]> & AdditionalResponseConfiguration): Promise<ApiResult<User[], void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getClientRegisteredEmployeesUrl(clientId),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    approvalsUrl(slug: string, code: string | undefined): string {
        let url_ = this.baseUrl + "/api/v1/approvals/{slug}?";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param code (optional) 
     * @return OK
     */
     async approvals(slug: string, code: string | undefined, requestConfig?: AxiosRequestConfig<SlugDto> & AdditionalResponseConfiguration): Promise<ApiResult<SlugDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.approvalsUrl(slug, code),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    approveUrl(slug: string): string {
        let url_ = this.baseUrl + "/api/v1/approvals/{slug}/approve";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async approve(slug: string, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "POST",
            url: this.approveUrl(slug),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    rejectUrl(slug: string): string {
        let url_ = this.baseUrl + "/api/v1/approvals/{slug}/reject";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async reject(slug: string, body: SlugRejectDto, requestConfig?: AxiosRequestConfig<WorkflowDto> & AdditionalResponseConfiguration): Promise<ApiResult<WorkflowDto, void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.rejectUrl(slug),
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    resendUrl(slug: string): string {
        let url_ = this.baseUrl + "/api/v1/approvals/{slug}/resend";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return Accepted
     */
     async resend(slug: string, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "POST",
            url: this.resendUrl(slug),
            headers: {
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    localFilesUploadUrl(externalReferenceId: string): string {
        let url_ = this.baseUrl + "/api/v1/local-files/upload/{externalReferenceId}";
        if (externalReferenceId === undefined || externalReferenceId === null)
            throw new globalThis.Error("The parameter 'externalReferenceId' must be defined.");
        url_ = url_.replace("{externalReferenceId}", encodeURIComponent("" + externalReferenceId));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param description (optional) 
     * @return Created
     */
     async localFilesUpload(externalReferenceId: string, description: string | undefined, requestConfig?: AxiosRequestConfig<LocalFileDto> & AdditionalResponseConfiguration): Promise<ApiResult<LocalFileDto, void>> {
      requestConfig ??= {};
        const content_ = new FormData();
        if (description === null || description === undefined)
            throw new globalThis.Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.localFilesUploadUrl(externalReferenceId),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    localFilesDownloadUrl(externalReferenceId: string, id: number): string {
        let url_ = this.baseUrl + "/api/v1/local-files/download/{externalReferenceId}/{id}";
        if (externalReferenceId === undefined || externalReferenceId === null)
            throw new globalThis.Error("The parameter 'externalReferenceId' must be defined.");
        url_ = url_.replace("{externalReferenceId}", encodeURIComponent("" + externalReferenceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return File content
     */
     async localFilesDownload(externalReferenceId: string, id: number, requestConfig?: AxiosRequestConfig<FileResponse> & AdditionalResponseConfiguration): Promise<ApiResult<FileResponse, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: this.localFilesDownloadUrl(externalReferenceId, id),
            headers: {
                "Accept": "application/octet-stream"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
                let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
                let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
                if (fileName) {
                    fileName = decodeURIComponent(fileName);
                } else {
                    fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                    fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
                }

                return {
                    type: 'success',
                    data: { fileName: fileName, status: response.status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: mapHeaders(response.headers) },
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    localFilesGetfilesUrl(externalReferenceId: string): string {
        let url_ = this.baseUrl + "/api/v1/local-files/{externalReferenceId}";
        if (externalReferenceId === undefined || externalReferenceId === null)
            throw new globalThis.Error("The parameter 'externalReferenceId' must be defined.");
        url_ = url_.replace("{externalReferenceId}", encodeURIComponent("" + externalReferenceId));
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async localFilesGetfiles(externalReferenceId: string, requestConfig?: AxiosRequestConfig<LocalFileDto[]> & AdditionalResponseConfiguration): Promise<ApiResult<LocalFileDto[], void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.localFilesGetfilesUrl(externalReferenceId),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    getAuditEntriesPaginatedUrl(page: number | undefined, size: number | undefined, externalReference: string[] | undefined, transactionId: string[] | undefined, createdBefore: string | undefined, createdAfter: string | undefined, createdBy: string[] | undefined, className: string[] | undefined, operation: Operation[] | undefined, createdByName: string | undefined, orderBy: string | undefined): string {
        let url_ = this.baseUrl + "/api/v1/audit-history?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (externalReference === null)
            throw new globalThis.Error("The parameter 'externalReference' cannot be null.");
        else if (externalReference !== undefined)
            externalReference && externalReference.forEach(item => { url_ += "externalReference=" + encodeURIComponent("" + item) + "&"; });
        if (transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            transactionId && transactionId.forEach(item => { url_ += "transactionId=" + encodeURIComponent("" + item) + "&"; });
        if (createdBefore === null)
            throw new globalThis.Error("The parameter 'createdBefore' cannot be null.");
        else if (createdBefore !== undefined)
            url_ += "createdBefore=" + encodeURIComponent("" + createdBefore) + "&";
        if (createdAfter === null)
            throw new globalThis.Error("The parameter 'createdAfter' cannot be null.");
        else if (createdAfter !== undefined)
            url_ += "createdAfter=" + encodeURIComponent("" + createdAfter) + "&";
        if (createdBy === null)
            throw new globalThis.Error("The parameter 'createdBy' cannot be null.");
        else if (createdBy !== undefined)
            createdBy && createdBy.forEach(item => { url_ += "createdBy=" + encodeURIComponent("" + item) + "&"; });
        if (className === null)
            throw new globalThis.Error("The parameter 'className' cannot be null.");
        else if (className !== undefined)
            className && className.forEach(item => { url_ += "className=" + encodeURIComponent("" + item) + "&"; });
        if (operation === null)
            throw new globalThis.Error("The parameter 'operation' cannot be null.");
        else if (operation !== undefined)
            operation && operation.forEach(item => { url_ += "operation=" + encodeURIComponent("" + item) + "&"; });
        if (createdByName === null)
            throw new globalThis.Error("The parameter 'createdByName' cannot be null.");
        else if (createdByName !== undefined)
            url_ += "createdByName=" + encodeURIComponent("" + createdByName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @param page (optional) Page number (default: 1)
     * @param size (optional) Page size (default: 50, max: 100)
     * @param externalReference (optional) Filter by external reference (workflow ID)
     * @param transactionId (optional) Filter by transaction ID
     * @param createdBefore (optional) Filter entries created before this date (ISO 8601 format)
     * @param createdAfter (optional) Filter entries created after this date (ISO 8601 format)
     * @param createdBy (optional) Filter by user ID who created the entry
     * @param className (optional) Filter by entity class name
     * @param operation (optional) Filter by operation type
     * @param createdByName (optional) Filter by user's full name (partial match)
     * @param orderBy (optional) Comma-separated list of fields to order by. Append :desc for descending order. Supported fields: createddate, classname, operation. Default: createddate:desc
     * @return OK
     */
     async getAuditEntriesPaginated(page: number | undefined, size: number | undefined, externalReference: string[] | undefined, transactionId: string[] | undefined, createdBefore: string | undefined, createdAfter: string | undefined, createdBy: string[] | undefined, className: string[] | undefined, operation: Operation[] | undefined, createdByName: string | undefined, orderBy: string | undefined, requestConfig?: AxiosRequestConfig<PaginatedResponseDtoOfAuditEntryDto> & AdditionalResponseConfiguration): Promise<ApiResult<PaginatedResponseDtoOfAuditEntryDto, void>> {
      requestConfig ??= {};
            let options_: AxiosRequestConfig = {
            method: "GET",
            url: this.getAuditEntriesPaginatedUrl(page, size, externalReference, transactionId, createdBefore, createdAfter, createdBy, className, operation, createdByName, orderBy),
            headers: {
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    deadLettersAllUrl(): string {
        let url_ = this.baseUrl + "/api/v1/dead-letters";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async deadLettersAll(body: DeadLetterEnvelopeGetRequest, requestConfig?: AxiosRequestConfig<DeadLetterEnvelopeResults[]> & AdditionalResponseConfiguration): Promise<ApiResult<DeadLetterEnvelopeResults[], void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.deadLettersAllUrl(),
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    data: response.data,
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    deadLettersUrl(): string {
        let url_ = this.baseUrl + "/api/v1/dead-letters";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async deadLetters(body: DeadLetterEnvelopeIdsRequest, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: this.deadLettersUrl(),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }

    replayUrl(): string {
        let url_ = this.baseUrl + "/api/v1/dead-letters/replay";
        url_ = url_.replace(/[?&]$/, "");
        return useConfig().configuration.baseApiUrl + url_;
    }

    /**
     * @return OK
     */
     async replay(body: DeadLetterEnvelopeIdsRequest, requestConfig?: AxiosRequestConfig<void> & AdditionalResponseConfiguration): Promise<ApiNoDataResult<void>> {
      requestConfig ??= {};
        const content_ = JSON.stringify(body);
            let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: this.replayUrl(),
            headers: {
                "Content-Type": "application/json",
            },
        };

        options_ = Object.assign(options_, requestConfig);

        try {
            const response = await axios.request(options_);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                if (requestConfig.successNotificationMessage) {
                  useToast().add({
                    title: requestConfig.successNotificationMessage,
                    color: 'success'
                  });
                }

                return {
                    type: 'success',
                    response: response,
                };
            } else if (response.status === 202) {
              return {
                type: 'accepted',
                response: response,
              };
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 401
            ) {
              return invokeErrorHandler(requestConfig.unauthenticatedHandler, response, "Authentication required");
            } else if (
               !requestConfig.disableDefaultErrorHandlers &&
              response.status === 403
            ) {
              return invokeErrorHandler(requestConfig.forbiddenHandler, response, "An error occurred: missing permissions");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 404
            ) {
              return invokeErrorHandler(requestConfig.notFoundHandler, response, "An error occurred: not found");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 409
            ) {
              return invokeErrorHandler(requestConfig.conflictHandler, response, "A conflict occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 400
            ) {
              return invokeErrorHandler(requestConfig.badRequestHandler, response, "An error occurred");
            } else if (
              !requestConfig.disableDefaultErrorHandlers &&
              response.status === 429
            ) {
              return invokeErrorHandler(requestConfig.rateLimitedHandler, response, "Too many requests");
            } else {
              return throwException(
                'A server side error occurred.',
                response.status,
                mapHeaders(response.headers),
                response.data
              );
            }
        } catch (err) {
          if (!requestConfig.disableDefaultErrorHandlers && isAxiosError(err) && err.code === 'ERR_NETWORK') {
            return invokeErrorHandler(requestConfig.apiDownHandler, err, "API is unavailable");
          } else {
            throw err;
          }
        }
    }
}

export const api = new Api();

export interface Addon {

    [key: string]: any;
}

export interface AddonBase {
    externalReference?: string;
    code?: string;

    [key: string]: any;
}

export interface AddonNolsAccessory {
    $type: AddonNolsAccessory_type;
    sequenceNumber?: string;
    manCode?: string;
    discountPercentage?: number;
    currency?: Currency | undefined;
    owner?: string;
    price?: number;
    priceAfterDiscount?: number;
    texts?: { [key: string]: string; };
    externalReference?: string;
    code?: string;

    [key: string]: any;
}

export interface AddonNolsELogBook {
    $type: AddonNolsELogBook_type;
    assemblyLocality: string;
    assemblyDateExp: string;
    orderSent: string;
    confirmationDate: string;
    externalReference: string;
    code?: string;

    [key: string]: any;
}

export interface AddonNolsService {
    $type: AddonNolsService_type;
    included?: boolean;
    monthlyRate?: number | undefined;
    kmRate?: number | undefined;
    currency?: Currency | undefined;
    descriptions?: { [key: string]: Description; };
    externalReference?: string;
    code?: string;

    [key: string]: any;
}

export interface AddonNolsWinterTyre {
    $type: AddonNolsWinterTyre_type;
    orderDate: string;
    externalReference: string;
    code?: string;

    [key: string]: any;
}

export interface AddonPressureSensor {
    $type: AddonPressureSensor_type;
    materialNumber?: string;
    brand?: string | undefined;
    quantity?: number;
    currency?: Currency | undefined;
    discount?: number;
    priceAfterDiscount?: number;
    texts?: { [key: string]: string; };
    externalReference?: string;
    code?: string;

    [key: string]: any;
}

export interface AddonRim {
    $type: AddonRim_type;
    rimDiameter?: number;
    materialNumber?: string;
    brand?: string | undefined;
    quantity?: number;
    currency?: Currency | undefined;
    discount?: number;
    priceAfterDiscount?: number;
    texts?: { [key: string]: string; };
    externalReference?: string;
    code?: string;

    [key: string]: any;
}

export interface AddonSapAccessory {
    $type: AddonSapAccessory_type;
    discountPercentage?: number;
    currency?: Currency | undefined;
    owner?: string;
    price?: number;
    priceAfterDiscount?: number;
    texts?: { [key: string]: string; };
    externalReference?: string;
    code?: string;

    [key: string]: any;
}

export interface AddonSapOption {
    $type: AddonSapOption_type;
    currency?: Currency | undefined;
    price?: number;
    description?: string | undefined;
    externalReference?: string;
    code?: string;

    [key: string]: any;
}

export interface AddonSapService {
    $type: AddonSapService_type;
    descriptions?: { [key: string]: string; };
    monthlyRate?: number | undefined;
    kmRate?: number | undefined;
    currency?: Currency | undefined;
    externalReference?: string;
    code?: string;

    [key: string]: any;
}

export interface AddonTyre {
    $type: AddonTyre_type;
    width?: number;
    profile?: number;
    rimDiameter?: number;
    tyresType?: string | undefined;
    materialNumber?: string;
    brand?: string | undefined;
    quantity?: number;
    currency?: Currency | undefined;
    discount?: number;
    priceAfterDiscount?: number;
    texts?: { [key: string]: string; };
    externalReference?: string;
    code?: string;

    [key: string]: any;
}

export interface ApprovalFlow {
    id: string;
    steps: ApprovalStep[];

    [key: string]: any;
}

export interface ApprovalFlowDto {
    steps: ApprovalStep[] | undefined;

    [key: string]: any;
}

export interface ApprovalStep {

    [key: string]: any;
}

export interface ApprovalStepDriverApprovalStep {
    $type?: ApprovalStepDriverApprovalStep_type;
    order: number;

    [key: string]: any;
}

export interface ApprovalStepFleetManagerApprovalStep {
    $type?: ApprovalStepFleetManagerApprovalStep_type;
    order: number;

    [key: string]: any;
}

export interface ApprovalStepGroupApprovalStep {
    $type?: ApprovalStepGroupApprovalStep_type;
    groupPath: string;
    order: number;

    [key: string]: any;
}

export interface ApprovalStepHrApprovalStep {
    $type?: ApprovalStepHrApprovalStep_type;
    order: number;

    [key: string]: any;
}

export interface ApprovalStepNotRegisteredUserApprovalStep {
    $type?: ApprovalStepNotRegisteredUserApprovalStep_type;
    email: string | undefined;
    order: number;

    [key: string]: any;
}

export interface ApprovalStepPersonApprovalStep {
    $type?: ApprovalStepPersonApprovalStep_type;
    keycloakId: string;
    order: number;

    [key: string]: any;
}

export interface ApprovalStepPurchaseSupportApprovalStep {
    $type?: ApprovalStepPurchaseSupportApprovalStep_type;
    order: number;

    [key: string]: any;
}

export interface ApprovalStepSupervisorApprovalStep {
    $type?: ApprovalStepSupervisorApprovalStep_type;
    email: string | undefined;
    order: number;

    [key: string]: any;
}

export interface Assignee {

    [key: string]: any;
}

export interface AssigneeBase {
    externalReference: string;
    id?: number;
    assignedDate?: string;

    [key: string]: any;
}

export interface AssigneeFlatDto {

    [key: string]: any;
}

export interface AssigneeFlatDtoBase {
    id: number;
    assignedDate: string;

    [key: string]: any;
}

export interface AssigneeFlatDtoGroupAssigneeFlatDto {
    $type: AssigneeFlatDtoGroupAssigneeFlatDto_type;
    group: string;
    id: number;
    assignedDate: string;

    [key: string]: any;
}

export interface AssigneeFlatDtoNotRegisteredAssigneeFlatDto {
    $type: AssigneeFlatDtoNotRegisteredAssigneeFlatDto_type;
    email: string;
    id: number;
    assignedDate: string;

    [key: string]: any;
}

export interface AssigneeFlatDtoPersonAssigneeFlatDto {
    $type: AssigneeFlatDtoPersonAssigneeFlatDto_type;
    keycloakId: string;
    fullName: string;
    id: number;
    assignedDate: string;

    [key: string]: any;
}

export interface AssigneeFlatDtoRoleAssigneeFlatDto {
    $type: AssigneeFlatDtoRoleAssigneeFlatDto_type;
    role: string;
    id: number;
    assignedDate: string;

    [key: string]: any;
}

export interface AssigneeGroupAssignee {
    $type: AssigneeGroupAssignee_type;
    group: string;
    externalReference: string;
    id?: number;
    assignedDate?: string;

    [key: string]: any;
}

export interface AssigneeNotRegisteredAssignee {
    $type: AssigneeNotRegisteredAssignee_type;
    email: string;
    externalReference: string;
    id?: number;
    assignedDate?: string;

    [key: string]: any;
}

export interface AssigneePersonAssignee {
    $type: AssigneePersonAssignee_type;
    keycloakId: string;
    user?: User | undefined;
    externalReference: string;
    id?: number;
    assignedDate?: string;

    [key: string]: any;
}

export interface AssigneeRoleAssignee {
    $type: AssigneeRoleAssignee_type;
    role: string;
    externalReference: string;
    id?: number;
    assignedDate?: string;

    [key: string]: any;
}

export interface AuditEntryDto {

    [key: string]: any;
}

export interface AuditEntryDtoAuditEntryDto {
    $type?: AuditEntryDtoAuditEntryDto_type;
    id: number;
    transactionId: string;
    createdDate: string;
    createdById: string;
    createdByFullName: string;
    operation: EntityState;
    fullClassName: string;
    className: string;
    changeEvent: AuditHistory[];

    [key: string]: any;
}

export interface AuditEntryDtoWorkflowEntityAuditEntryDto {
    $type?: AuditEntryDtoWorkflowEntityAuditEntryDto_type;
    externalReference: string;
    id: number;
    transactionId: string;
    createdDate: string;
    createdById: string;
    createdByFullName: string;
    operation: EntityState;
    fullClassName: string;
    className: string;
    changeEvent: AuditHistory[];

    [key: string]: any;
}

export interface AuditHistory {
    propertyName: string;
    oldValue: any;
    newValue: any;

    [key: string]: any;
}

export interface BenefitInKind {
    fullBenefitValue: number;
    limitedBenefitValue: number;

    [key: string]: any;
}

export interface BusinessPartner {

    [key: string]: any;
}

export interface BusinessPartnerAddress {
    partnerId: string;
    name: string;
    street: string | undefined;
    streetNumber: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;

    [key: string]: any;
}

export interface BusinessPartnerBusinessPartner {
    $sourceSystem?: BusinessPartnerBusinessPartner_sourceSystem;
    id: string;
    name: string;

    [key: string]: any;
}

export interface BusinessPartnerNolsBusinessPartner {
    $sourceSystem?: BusinessPartnerNolsBusinessPartner_sourceSystem;
    id: string;
    name: string;

    [key: string]: any;
}

export interface BusinessPartnerSapBusinessPartner {
    $sourceSystem?: BusinessPartnerSapBusinessPartner_sourceSystem;
    id: string;
    name: string;

    [key: string]: any;
}

export interface ContactPersonDto {
    id: string;
    fullName: string | undefined;
    email: string | undefined;
    phone: string | undefined;

    [key: string]: any;
}

export interface CostCenterDto {
    organizationName: string | undefined;
    id: string;
    name: string | undefined;

    [key: string]: any;
}

export type Country = "NotDefined" | "Czechia" | "Finland";

export const CountryKeys: Country[] = ["NotDefined", "Czechia", "Finland"];
    
export const Country: Record<Country, Country> = {
    "NotDefined": "NotDefined",
    "Czechia": "Czechia",
    "Finland": "Finland"
};

export interface CreateUserDto {
    firstName: string;
    lastName: string;
    email: string;
    groups: string[];
    clientId: string;
    employerBpIds: string[];
    sapUserId: string | undefined;

    [key: string]: any;
}

export type Currency = "CZK" | "EUR" | "NotDefined" | "USD";

export const CurrencyKeys: Currency[] = ["CZK", "EUR", "NotDefined", "USD"];
    
export const Currency: Record<Currency, Currency> = {
    "CZK": "CZK",
    "EUR": "EUR",
    "NotDefined": "NotDefined",
    "USD": "USD"
};

export interface CzechiaQuotationFinancialsDto {
    transactionCurrency?: Currency;
    calculationBase?: number;
    duration?: number;
    mileage?: number;
    monthlyRate?: number;
    monthlyRateInclVat?: number;
    basePrice?: number;
    basePriceAfterDiscount?: number;
    investment?: number;
    investmentInclVat?: number;
    vatRate?: number;
    mvaLess?: MVA;
    mvaMore?: MVA;

    [key: string]: any;
}

export interface DeadLetterEnvelope {
    id: string;
    executionTime: string | undefined;
    envelope: Envelope;
    messageType: string;
    receivedAt: string;
    source: string;
    exceptionType: string;
    exceptionMessage: string;
    sentAt: string;
    replayable: boolean;
    message?: any;

    [key: string]: any;
}

export interface DeadLetterEnvelopeGetRequest {
    limit?: number;
    pageNumber?: number;
    messageType?: string | undefined;
    exceptionType?: string | undefined;
    exceptionMessage?: string | undefined;
    from?: string | undefined;
    until?: string | undefined;
    tenantId?: string | undefined;
    databaseUri?: string | undefined;

    [key: string]: any;
}

export interface DeadLetterEnvelopeIdsRequest {
    ids?: string[];
    tenantId?: string | undefined;

    [key: string]: any;
}

export interface DeadLetterEnvelopeResults {
    totalCount?: number;
    envelopes?: DeadLetterEnvelope[];
    pageNumber?: number;
    databaseUri?: string | undefined;

    [key: string]: any;
}

export interface DeliveryDto {

    [key: string]: any;
}

export interface DeliveryDtoCzechiaDeliveryDto {
    $type?: DeliveryDtoCzechiaDeliveryDto_type;
    arrivedAtDealer?: boolean;
    externalReference: string;
    currentProcessStep: DeliveryStep;
    vin?: string | undefined;
    cO2?: number | undefined;
    licensePlate?: string | undefined;
    licensePlateFilledDate?: string | undefined;
    registrationDate?: string | undefined;
    handoverDate?: string | undefined;
    handoverMileage?: number | undefined;
    assignees?: Assignee[] | undefined;

    [key: string]: any;
}

export interface DeliveryDtoFinlandDeliveryDto {
    $type?: DeliveryDtoFinlandDeliveryDto_type;
    externalReference: string;
    currentProcessStep: DeliveryStep;
    vin?: string | undefined;
    cO2?: number | undefined;
    licensePlate?: string | undefined;
    licensePlateFilledDate?: string | undefined;
    registrationDate?: string | undefined;
    handoverDate?: string | undefined;
    handoverMileage?: number | undefined;
    assignees?: Assignee[] | undefined;

    [key: string]: any;
}

export interface DeliveryDtoNolsDeliveryDto {
    $type?: DeliveryDtoNolsDeliveryDto_type;
    techCertificateSendDate?: string | undefined;
    plateRequestedDate?: string | undefined;
    driverSetPrintedDate?: string | undefined;
    startDate?: string | undefined;
    handoverRequestedDate?: string | undefined;
    externalReference: string;
    currentProcessStep: DeliveryStep;
    vin?: string | undefined;
    cO2?: number | undefined;
    licensePlate?: string | undefined;
    licensePlateFilledDate?: string | undefined;
    registrationDate?: string | undefined;
    handoverDate?: string | undefined;
    handoverMileage?: number | undefined;
    assignees?: Assignee[] | undefined;

    [key: string]: any;
}

export interface DeliveryProtocolDto {
    handoverDate: string;
    handoverMileage: number;

    [key: string]: any;
}

export type DeliveryStep = "NotDefined" | "NotActive" | "Waiting" | "VehicleRegistration" | "HandoverPreparation" | "Handover" | "Parked" | "Completed";

export const DeliveryStepKeys: DeliveryStep[] = ["NotDefined", "NotActive", "Waiting", "VehicleRegistration", "HandoverPreparation", "Handover", "Parked", "Completed"];
    
export const DeliveryStep: Record<DeliveryStep, DeliveryStep> = {
    "NotDefined": "NotDefined",
    "NotActive": "NotActive",
    "Waiting": "Waiting",
    "VehicleRegistration": "VehicleRegistration",
    "HandoverPreparation": "HandoverPreparation",
    "Handover": "Handover",
    "Parked": "Parked",
    "Completed": "Completed"
};

export interface Description {
    text: string;
    specification: string;

    [key: string]: any;
}

export interface DownloadContentManagerItemDto {
    pid: string;

    [key: string]: any;
}

export interface DriverDto {

    [key: string]: any;
}

export interface DriverDtoDriverDto {
    $type?: DriverDtoDriverDto_type;
    businessPartnerId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    staffId: string | undefined;
    benefitLevel: string | undefined;

    [key: string]: any;
}

export interface DriverDtoDriverSsnDto {
    $type?: DriverDtoDriverSsnDto_type;
    ssn: string | undefined;
    businessPartnerId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    staffId?: string | undefined;
    benefitLevel?: string | undefined;

    [key: string]: any;
}

export interface EmployerPartnerDto {
    bpId: string;
    name: string;

    [key: string]: any;
}

export type EntityState = "Detached" | "Unchanged" | "Deleted" | "Modified" | "Added";

export const EntityStateKeys: EntityState[] = ["Detached", "Unchanged", "Deleted", "Modified", "Added"];
    
export const EntityState: Record<EntityState, EntityState> = {
    "Detached": "Detached",
    "Unchanged": "Unchanged",
    "Deleted": "Deleted",
    "Modified": "Modified",
    "Added": "Added"
};

export interface Envelope {
    headers?: { [key: string]: string; };
    deliverBy?: string | undefined;
    ackRequested?: boolean;
    scheduledTime?: string | undefined;
    scheduleDelay?: string | undefined;
    data?: string | undefined;
    message?: any;
    attempts?: number;
    sendAttempts?: number;
    sentAt?: string;
    source?: string | undefined;
    messageType?: string | undefined;
    replyUri?: string | undefined;
    contentType?: string | undefined;
    correlationId?: string | undefined;
    sagaId?: string | undefined;
    conversationId?: string;
    destination?: string | undefined;
    parentId?: string | undefined;
    tenantId?: string | undefined;
    userName?: string | undefined;
    acceptedContentTypes?: string[];
    id?: string;
    replyRequested?: string | undefined;
    topicName?: string | undefined;
    endpointName?: string | undefined;
    wasPersistedInOutbox?: boolean;
    groupId?: string | undefined;
    deduplicationId?: string | undefined;
    partitionKey?: string | undefined;
    offset?: number;
    partitionId?: number | undefined;
    keepUntil?: string | undefined;

    [key: string]: any;
}

export type Event = "None" | "StepCompleted" | "QuotationRejected" | "PurchaseOrderRejected" | "QuotationApprovalCompleted" | "ImportedFromNols" | "ImportedFromSap" | "RequestedDeliveryDateFilled" | "RequestedDeliveryDateChanged" | "DealerExpectedDeliveryDateFilled" | "DealerExpectedDeliveryDateChanged" | "PurchaseOrderCreated" | "WorkflowStatusChanged" | "DeliveryStarting" | "SlugCreated" | "FailedToFindAssignee" | "ConfirmationCodeRequested" | "ConfirmationCodeVerified" | "ConfirmationCodeFailed" | "QuotationRestarted" | "PurchaseOrderRestarted" | "SsnConfirmed" | "WorkflowParked" | "WorkflowUnparked" | "PurchaseOrderUpdated" | "SapCommandFailed";

export const EventKeys: Event[] = ["None", "StepCompleted", "QuotationRejected", "PurchaseOrderRejected", "QuotationApprovalCompleted", "ImportedFromNols", "ImportedFromSap", "RequestedDeliveryDateFilled", "RequestedDeliveryDateChanged", "DealerExpectedDeliveryDateFilled", "DealerExpectedDeliveryDateChanged", "PurchaseOrderCreated", "WorkflowStatusChanged", "DeliveryStarting", "SlugCreated", "FailedToFindAssignee", "ConfirmationCodeRequested", "ConfirmationCodeVerified", "ConfirmationCodeFailed", "QuotationRestarted", "PurchaseOrderRestarted", "SsnConfirmed", "WorkflowParked", "WorkflowUnparked", "PurchaseOrderUpdated", "SapCommandFailed"];
    
export const Event: Record<Event, Event> = {
    "None": "None",
    "StepCompleted": "StepCompleted",
    "QuotationRejected": "QuotationRejected",
    "PurchaseOrderRejected": "PurchaseOrderRejected",
    "QuotationApprovalCompleted": "QuotationApprovalCompleted",
    "ImportedFromNols": "ImportedFromNols",
    "ImportedFromSap": "ImportedFromSap",
    "RequestedDeliveryDateFilled": "RequestedDeliveryDateFilled",
    "RequestedDeliveryDateChanged": "RequestedDeliveryDateChanged",
    "DealerExpectedDeliveryDateFilled": "DealerExpectedDeliveryDateFilled",
    "DealerExpectedDeliveryDateChanged": "DealerExpectedDeliveryDateChanged",
    "PurchaseOrderCreated": "PurchaseOrderCreated",
    "WorkflowStatusChanged": "WorkflowStatusChanged",
    "DeliveryStarting": "DeliveryStarting",
    "SlugCreated": "SlugCreated",
    "FailedToFindAssignee": "FailedToFindAssignee",
    "ConfirmationCodeRequested": "ConfirmationCodeRequested",
    "ConfirmationCodeVerified": "ConfirmationCodeVerified",
    "ConfirmationCodeFailed": "ConfirmationCodeFailed",
    "QuotationRestarted": "QuotationRestarted",
    "PurchaseOrderRestarted": "PurchaseOrderRestarted",
    "SsnConfirmed": "SsnConfirmed",
    "WorkflowParked": "WorkflowParked",
    "WorkflowUnparked": "WorkflowUnparked",
    "PurchaseOrderUpdated": "PurchaseOrderUpdated",
    "SapCommandFailed": "SapCommandFailed"
};

export interface EventLog {
    id?: number;
    externalReference: string;
    workflowStatus: WorkflowStatus;
    eventType: Event;
    description?: string;
    createdDate: string;
    createdById: string;
    createdBy?: User;

    [key: string]: any;
}

export interface FinlandQuotationFinancialsDto {
    transactionCurrency?: Currency;
    calculationBase?: number;
    duration?: number;
    mileage?: number;
    monthlyRate?: number;
    monthlyRateInclVat?: number;
    basePrice?: number;
    basePriceAfterDiscount?: number;
    investment?: number;
    investmentInclVat?: number;
    vatRate?: number;
    mvaLess?: MVA;
    mvaMore?: MVA;

    [key: string]: any;
}

export interface GroupDto {
    keycloakId: string;
    name: string;
    path: string;

    [key: string]: any;
}

export type HomologationClass = "NA" | "M1" | "M2" | "M3" | "N1" | "N2" | "N3" | "O1" | "O2" | "O3" | "O4";

export const HomologationClassKeys: HomologationClass[] = ["NA", "M1", "M2", "M3", "N1", "N2", "N3", "O1", "O2", "O3", "O4"];
    
export const HomologationClass: Record<HomologationClass, HomologationClass> = {
    "NA": "NA",
    "M1": "M1",
    "M2": "M2",
    "M3": "M3",
    "N1": "N1",
    "N2": "N2",
    "N3": "N3",
    "O1": "O1",
    "O2": "O2",
    "O3": "O3",
    "O4": "O4"
};

export interface HttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export type Initiator = "NotDefined" | "Supplier" | "Client";

export const InitiatorKeys: Initiator[] = ["NotDefined", "Supplier", "Client"];
    
export const Initiator: Record<Initiator, Initiator> = {
    "NotDefined": "NotDefined",
    "Supplier": "Supplier",
    "Client": "Client"
};

export interface ItemDto {
    pid: string;
    itemtypeName: string;
    createdTimestamp: string;
    fileName: string | undefined;
    documentType: string | undefined;

    [key: string]: any;
}

export interface LocalFileDto {
    id: number;
    originalName: string;
    contentType: string;
    description: string | undefined;
    size: number;
    uploadedAt: string;

    [key: string]: any;
}

export interface MVA {
    rate: number;
    listedRates: string;

    [key: string]: any;
}

export interface NolsFuelCard {
    externalReference: string;
    type: string;
    orderConfirmedDate: string;
    validFrom: string;

    [key: string]: any;
}

export interface Note {
    id?: number;
    externalReference?: string;
    text?: string;
    createdDate?: string;
    createdById?: string;
    createdBy?: User | undefined;

    [key: string]: any;
}

export interface OrganizationDto {
    keycloakId: string;
    name: string;

    [key: string]: any;
}

export interface OrganizationPartnerDto {

    [key: string]: any;
}

export interface OrganizationPartnerDtoCostCenterDto {
    $type?: OrganizationPartnerDtoCostCenterDto_type;
    organizationName: string | undefined;
    id: string;
    name: string | undefined;

    [key: string]: any;
}

export interface OrganizationPartnerDtoOrganizationPartnerDto {
    $type?: OrganizationPartnerDtoOrganizationPartnerDto_type;
    id: string;
    name: string | undefined;

    [key: string]: any;
}

export interface OrganizationPartnerDtoSupplierPartnerDto {
    $type?: OrganizationPartnerDtoSupplierPartnerDto_type;
    email: string | undefined;
    id: string;
    name: string | undefined;

    [key: string]: any;
}

export interface PaginatedResponseDtoOfAuditEntryDto {
    pageSize?: number;
    currentPage?: number;
    totalItems?: number;
    totalPages?: number;
    links?: { [key: string]: string; } | undefined;
    data?: AuditEntryDto[];

    [key: string]: any;
}

export interface PaginatedResponseDtoOfBusinessPartner {
    pageSize?: number;
    currentPage?: number;
    totalItems?: number;
    totalPages?: number;
    links?: { [key: string]: string; } | undefined;
    data?: BusinessPartner[];

    [key: string]: any;
}

export interface PaginatedResponseDtoOfSapFileInfoDto {
    pageSize?: number;
    currentPage?: number;
    totalItems?: number;
    totalPages?: number;
    links?: { [key: string]: string; } | undefined;
    data?: SapFileInfoDto[];

    [key: string]: any;
}

export interface PaginatedResponseDtoOfWorkflowDto {
    pageSize?: number;
    currentPage?: number;
    totalItems?: number;
    totalPages?: number;
    links?: { [key: string]: string; } | undefined;
    data?: WorkflowDto[];

    [key: string]: any;
}

export interface PaginatedResponseDtoOfWorkflowFlatDto {
    pageSize?: number;
    currentPage?: number;
    totalItems?: number;
    totalPages?: number;
    links?: { [key: string]: string; } | undefined;
    data?: WorkflowFlatDto[];

    [key: string]: any;
}

export interface PersonPartnerDto {
    id: string;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;

    [key: string]: any;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface PurchaseOrderAddonDto {

    [key: string]: any;
}

export interface PurchaseOrderAddonDtoPurchaseOrderAccessoryDto {
    $type?: PurchaseOrderAddonDtoPurchaseOrderAccessoryDto_type;
    materialNumber?: string;
    scheduleLine?: string;
    descriptions?: { [key: string]: string; };
    discountRate?: number;
    discountAmount?: number;
    priceAfterDiscount?: number;
    code?: string;
    listPrice?: number;

    [key: string]: any;
}

export interface PurchaseOrderAddonDtoPurchaseOrderOptionDto {
    $type?: PurchaseOrderAddonDtoPurchaseOrderOptionDto_type;
    description?: string | undefined;
    code?: string;
    listPrice?: number;

    [key: string]: any;
}

export interface PurchaseOrderAddonDtoPurchaseOrderTyreDto {
    $type?: PurchaseOrderAddonDtoPurchaseOrderTyreDto_type;
    materialNumber?: string;
    scheduleLine?: string;
    descriptions?: { [key: string]: string; };
    discountRate?: number;
    discountAmount?: number;
    priceAfterDiscount?: number;
    code?: string;
    listPrice?: number;

    [key: string]: any;
}

export interface PurchaseOrderDto {

    [key: string]: any;
}

export interface PurchaseOrderDtoCzechiaVehicleOrderDto {
    $type: PurchaseOrderDtoCzechiaVehicleOrderDto_type;
    currentProcessStep: VehicleOrderStep;
    dealerExpectedDeliveryDate?: string | undefined;
    drivaliaExpectedDeliveryDate?: string | undefined;
    poNumber?: string;
    itemNumber?: string;
    supplierMaterialNumber?: string;
    scheduleLine?: string;
    supplierInternalOrderNumber?: string | undefined;
    externalReference: string;
    number: string;
    supplierId?: string;
    supplier?: BusinessPartner;
    sourceSystemCreatedDate?: string;
    assignees?: Assignee[] | undefined;

    [key: string]: any;
}

export interface PurchaseOrderDtoFinlandVehicleOrderDto {
    $type: PurchaseOrderDtoFinlandVehicleOrderDto_type;
    financials: VehicleOrderFinancialsDto;
    addons?: PurchaseOrderAddonDto[];
    importVersion?: number;
    currentProcessStep: VehicleOrderStep;
    dealerExpectedDeliveryDate?: string | undefined;
    drivaliaExpectedDeliveryDate?: string | undefined;
    poNumber?: string;
    itemNumber?: string;
    supplierMaterialNumber?: string;
    scheduleLine?: string;
    supplierInternalOrderNumber?: string | undefined;
    externalReference: string;
    number: string;
    supplierId?: string;
    supplier?: BusinessPartner;
    sourceSystemCreatedDate?: string;
    assignees?: Assignee[] | undefined;

    [key: string]: any;
}

export interface PurchaseOrderDtoNolsOrderDto {
    $type?: PurchaseOrderDtoNolsOrderDto_type;
    currentProcessStep?: VehicleOrderStep;
    dealerExpectedDeliveryDate?: string | undefined;
    drivaliaExpectedDeliveryDate?: string | undefined;
    contactEmailForPO?: string[];
    externalReference?: string;
    number?: string;
    supplierId?: string;
    supplier?: BusinessPartner;
    sourceSystemCreatedDate?: string;
    assignees?: Assignee[] | undefined;

    [key: string]: any;
}

export interface PurchaseOrderDtoTyreOrderDto {
    $type: PurchaseOrderDtoTyreOrderDto_type;
    currentProcessStep: TyreOrderStep;
    tyreLocationAddress?: string | undefined;
    deliveryDate?: string | undefined;
    financials: TyreOrderFinancialsDto;
    tyreName?: string | undefined;
    quantity?: number;
    netPrice?: number;
    tyreWidth?: number;
    tyreProfile?: number;
    rimDiameter?: number;
    tyresType?: string | undefined;
    rimSensor?: string | undefined;
    importVersion?: number;
    poNumber?: string;
    itemNumber?: string;
    supplierMaterialNumber?: string;
    scheduleLine?: string;
    supplierInternalOrderNumber?: string | undefined;
    externalReference: string;
    number: string;
    supplierId?: string;
    supplier?: BusinessPartner;
    sourceSystemCreatedDate?: string;
    assignees?: Assignee[] | undefined;

    [key: string]: any;
}

export interface PurchaseOrderFlatDto {

    [key: string]: any;
}

export interface PurchaseOrderFlatDtoTyreOrderFlatDto {
    $type: PurchaseOrderFlatDtoTyreOrderFlatDto_type;
    currentProcessStep: TyreOrderStep;
    number: string;
    assignees?: AssigneeFlatDto[] | undefined;
    supplierId: string;
    supplierName: string | undefined;

    [key: string]: any;
}

export interface PurchaseOrderFlatDtoVehicleOrderFlatDto {
    $type: PurchaseOrderFlatDtoVehicleOrderFlatDto_type;
    currentProcessStep: VehicleOrderStep;
    number: string;
    assignees?: AssigneeFlatDto[] | undefined;
    supplierId: string;
    supplierName: string | undefined;

    [key: string]: any;
}

export interface QuotationDto {

    [key: string]: any;
}

export interface QuotationDtoCzechiaQuotationDto {
    $type?: QuotationDtoCzechiaQuotationDto_type;
    financials?: CzechiaQuotationFinancialsDto;
    validTo?: string | undefined;
    externalReference: string;
    currentProcessStep: QuotationStep;
    number?: string;
    requestedDeliveryDateScenario?: RequestedDeliveryDateScenario | undefined;
    dealerId?: string;
    dealer?: BusinessPartner | undefined;
    assignees?: Assignee[] | undefined;
    addons?: Addon[] | undefined;

    [key: string]: any;
}

export interface QuotationDtoFinlandQuotationDto {
    $type?: QuotationDtoFinlandQuotationDto_type;
    clientApprovalConfiguration?: ApprovalStep[] | undefined;
    _currentClientApprovalStep?: number;
    description?: string | undefined;
    ssnConfirmed?: boolean;
    commercialProduct?: { [key: string]: string; };
    financialProduct?: { [key: string]: string; };
    benefitInKind?: BenefitInKind | undefined;
    tyrePackage?: TyrePackageDto | undefined;
    importVersion?: number;
    financials?: FinlandQuotationFinancialsDto;
    validTo?: string | undefined;
    externalReference: string;
    currentProcessStep: QuotationStep;
    number?: string;
    requestedDeliveryDateScenario?: RequestedDeliveryDateScenario | undefined;
    dealerId?: string;
    dealer?: BusinessPartner | undefined;
    assignees?: Assignee[] | undefined;
    addons?: Addon[] | undefined;

    [key: string]: any;
}

export interface QuotationDtoNolsQuotationDto {
    $type?: QuotationDtoNolsQuotationDto_type;
    fuelCards?: NolsFuelCard[] | undefined;
    isPoolCar?: boolean;
    profitCenter?: number;
    initialQuotationNumber?: string | undefined;
    financials?: CzechiaQuotationFinancialsDto;
    externalReference: string;
    currentProcessStep: QuotationStep;
    number?: string;
    requestedDeliveryDateScenario?: RequestedDeliveryDateScenario | undefined;
    dealerId?: string;
    dealer?: BusinessPartner | undefined;
    assignees?: Assignee[] | undefined;
    addons?: Addon[] | undefined;

    [key: string]: any;
}

export interface QuotationFlatDto {
    currentProcessStep: QuotationStep;
    assignees?: AssigneeFlatDto[] | undefined;
    businessSolutionQuotation: string;

    [key: string]: any;
}

export type QuotationStep = "NotDefined" | "SchemaFinalization" | "ClientApproval" | "ClientAccountAcceptation" | "OrderCreation" | "Parked" | "Rejection" | "Rejected" | "Completed" | "DriverApproval" | "HRApproval" | "FleetManagerApproval" | "SupervisorApproval" | "GroupApproval" | "PurchaseSupportApproval" | "PersonApproval" | "NotRegisteredUserApproval";

export const QuotationStepKeys: QuotationStep[] = ["NotDefined", "SchemaFinalization", "ClientApproval", "ClientAccountAcceptation", "OrderCreation", "Parked", "Rejection", "Rejected", "Completed", "DriverApproval", "HRApproval", "FleetManagerApproval", "SupervisorApproval", "GroupApproval", "PurchaseSupportApproval", "PersonApproval", "NotRegisteredUserApproval"];
    
export const QuotationStep: Record<QuotationStep, QuotationStep> = {
    "NotDefined": "NotDefined",
    "SchemaFinalization": "SchemaFinalization",
    "ClientApproval": "ClientApproval",
    "ClientAccountAcceptation": "ClientAccountAcceptation",
    "OrderCreation": "OrderCreation",
    "Parked": "Parked",
    "Rejection": "Rejection",
    "Rejected": "Rejected",
    "Completed": "Completed",
    "DriverApproval": "DriverApproval",
    "HRApproval": "HRApproval",
    "FleetManagerApproval": "FleetManagerApproval",
    "SupervisorApproval": "SupervisorApproval",
    "GroupApproval": "GroupApproval",
    "PurchaseSupportApproval": "PurchaseSupportApproval",
    "PersonApproval": "PersonApproval",
    "NotRegisteredUserApproval": "NotRegisteredUserApproval"
};

export interface RejectionInitiatorDto {
    initiator: Initiator;

    [key: string]: any;
}

export interface RejectionReasonDto {
    reason: string;

    [key: string]: any;
}

export interface ReplacedCar {
    licensePlate?: string | undefined;
    startDate?: string;
    endDate?: string;

    [key: string]: any;
}

export type RequestedDeliveryDateMode = "None" | "ASAP" | "EQ" | "GE" | "LE";

export const RequestedDeliveryDateModeKeys: RequestedDeliveryDateMode[] = ["None", "ASAP", "EQ", "GE", "LE"];
    
export const RequestedDeliveryDateMode: Record<RequestedDeliveryDateMode, RequestedDeliveryDateMode> = {
    "None": "None",
    "ASAP": "ASAP",
    "EQ": "EQ",
    "GE": "GE",
    "LE": "LE"
};

export interface RequestedDeliveryDateScenario {

    [key: string]: any;
}

export interface RequestedDeliveryDateScenarioDeliveryAfterDate {
    $type?: RequestedDeliveryDateScenarioDeliveryAfterDate_type;
    date: string;
    mode?: RequestedDeliveryDateMode;

    [key: string]: any;
}

export interface RequestedDeliveryDateScenarioDeliveryASAP {
    $type?: RequestedDeliveryDateScenarioDeliveryASAP_type;
    mode?: RequestedDeliveryDateMode;

    [key: string]: any;
}

export interface RequestedDeliveryDateScenarioDeliveryBeforeDate {
    $type?: RequestedDeliveryDateScenarioDeliveryBeforeDate_type;
    date: string;
    mode?: RequestedDeliveryDateMode;

    [key: string]: any;
}

export interface RequestedDeliveryDateScenarioDeliveryOnDate {
    $type?: RequestedDeliveryDateScenarioDeliveryOnDate_type;
    date: string;
    mode?: RequestedDeliveryDateMode;

    [key: string]: any;
}

export interface ResendResultDto {
    count: number;
    emails: string[];

    [key: string]: any;
}

export interface RimDto {
    rimDiameter?: number;
    code?: string;
    materialNumber?: string;
    brand?: string | undefined;
    quantity?: number;
    texts?: { [key: string]: string; };

    [key: string]: any;
}

export interface SapFileInfoDto {
    name: string;
    createdUtc: string;
    sizeBytes: number;

    [key: string]: any;
}

export interface SlugDto {
    workflowDto: WorkflowDto;
    confirmationToken: string;

    [key: string]: any;
}

export interface SlugRejectDto {
    reason: string | undefined;

    [key: string]: any;
}

export interface SsnDto {
    ssn: string;

    [key: string]: any;
}

export interface SupplierPartnerDto {
    email: string | undefined;
    id: string;
    name: string | undefined;

    [key: string]: any;
}

export interface SupplierSalesPersonDto {
    id: string;
    fullName: string | undefined;
    email: string | undefined;
    phone: string | undefined;

    [key: string]: any;
}

export interface TpmsDto {
    code?: string;
    materialNumber?: string;
    brand?: string | undefined;
    quantity?: number;
    texts?: { [key: string]: string; };

    [key: string]: any;
}

export interface TyreDto {
    width?: number;
    profile?: number;
    rimDiameter?: number;
    tyresType?: string | undefined;
    code?: string;
    materialNumber?: string;
    brand?: string | undefined;
    quantity?: number;
    texts?: { [key: string]: string; };

    [key: string]: any;
}

export interface TyreFinancialsTotalDto {
    discount?: number;
    priceAfterDiscount?: number;
    currency?: Currency | undefined;

    [key: string]: any;
}

export interface TyreOrderFinancialsDto {
    transactionCurrency: Currency;
    listPrice: number;
    discountRate: number;
    discountAmount: number;
    priceAfterDiscount: number;

    [key: string]: any;
}

export type TyreOrderStep = "NotDefined" | "SupplierApproval" | "SupplierAcceptation" | "DeliveryConfirmation" | "Rejection" | "Rejected" | "Parked" | "Delivered";

export const TyreOrderStepKeys: TyreOrderStep[] = ["NotDefined", "SupplierApproval", "SupplierAcceptation", "DeliveryConfirmation", "Rejection", "Rejected", "Parked", "Delivered"];
    
export const TyreOrderStep: Record<TyreOrderStep, TyreOrderStep> = {
    "NotDefined": "NotDefined",
    "SupplierApproval": "SupplierApproval",
    "SupplierAcceptation": "SupplierAcceptation",
    "DeliveryConfirmation": "DeliveryConfirmation",
    "Rejection": "Rejection",
    "Rejected": "Rejected",
    "Parked": "Parked",
    "Delivered": "Delivered"
};

export interface TyrePackageDto {
    tyres?: TyreDto[];
    rims?: RimDto[];
    tpms?: TpmsDto[];
    financialsTotal?: TyreFinancialsTotalDto | undefined;

    [key: string]: any;
}

export interface UnparkDecisionDto {
    scenario: UnparkScenario;

    [key: string]: any;
}

export interface UnparkOrderDecisionDto {
    scenario: UnparkOrderScenario;

    [key: string]: any;
}

export type UnparkOrderScenario = "NotDefined" | "Park" | "Restart" | "NoRestart";

export const UnparkOrderScenarioKeys: UnparkOrderScenario[] = ["NotDefined", "Park", "Restart", "NoRestart"];
    
export const UnparkOrderScenario: Record<UnparkOrderScenario, UnparkOrderScenario> = {
    "NotDefined": "NotDefined",
    "Park": "Park",
    "Restart": "Restart",
    "NoRestart": "NoRestart"
};

export type UnparkScenario = "NotDefined" | "RestartFromQuotation" | "RestartFromPurchaseOrder" | "NoRestart";

export const UnparkScenarioKeys: UnparkScenario[] = ["NotDefined", "RestartFromQuotation", "RestartFromPurchaseOrder", "NoRestart"];
    
export const UnparkScenario: Record<UnparkScenario, UnparkScenario> = {
    "NotDefined": "NotDefined",
    "RestartFromQuotation": "RestartFromQuotation",
    "RestartFromPurchaseOrder": "RestartFromPurchaseOrder",
    "NoRestart": "NoRestart"
};

export interface User {
    keycloakId: string;
    fullName: string;

    [key: string]: any;
}

export interface ValidationErrorDetail {
    errorMessage: string;
    errorCode: string | undefined;

    [key: string]: any;
}

export interface ValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export interface ValidationProblemDetailsWithCodes {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors: { [key: string]: ValidationErrorDetail[]; };

    [key: string]: any;
}

export interface VehicleDto {
    externalReference?: string;
    manufacturerCode?: string;
    manufacturer?: string;
    model?: string;
    trim?: string;
    homologation?: HomologationClass;
    category?: string;
    powerKW?: number;
    numberOfSeats?: number;
    numberOfTyres?: number;
    numberOfAxles?: number;
    transmission?: string;
    vehicleColor?: string;
    upholsteryColor?: string;
    upholsteryMaterial?: string;
    isVehicleInStore?: boolean;
    modelDescription?: { [key: string]: string; };

    [key: string]: any;
}

export interface VehicleFlatDto {
    externalReference: string;
    brand: string;
    model: string;

    [key: string]: any;
}

export interface VehicleOrderFinancialsDto {
    transactionCurrency: Currency;
    listPrice: number;
    discountRate: number;
    discountAmount: number;
    deliveryCost: number;
    registrationTax: number;
    registrationCost: number;
    optionsListPriceSum: number;
    optionsDiscountRateSum: number;
    optionsDiscountAmountSum: number;
    optionsRegistrationTaxSum: number;

    [key: string]: any;
}

export type VehicleOrderStep = "NotDefined" | "KamApproval" | "ODApproval" | "DealerAcceptation" | "DealerConfirmation" | "DealerRejectionConfirmation" | "DealerRejection" | "Rejected" | "Parked" | "Completed";

export const VehicleOrderStepKeys: VehicleOrderStep[] = ["NotDefined", "KamApproval", "ODApproval", "DealerAcceptation", "DealerConfirmation", "DealerRejectionConfirmation", "DealerRejection", "Rejected", "Parked", "Completed"];
    
export const VehicleOrderStep: Record<VehicleOrderStep, VehicleOrderStep> = {
    "NotDefined": "NotDefined",
    "KamApproval": "KamApproval",
    "ODApproval": "ODApproval",
    "DealerAcceptation": "DealerAcceptation",
    "DealerConfirmation": "DealerConfirmation",
    "DealerRejectionConfirmation": "DealerRejectionConfirmation",
    "DealerRejection": "DealerRejection",
    "Rejected": "Rejected",
    "Parked": "Parked",
    "Completed": "Completed"
};

export interface WorkflowDto {

    [key: string]: any;
}

export interface WorkflowDtoCzechiaWorkflowDto {
    $type?: WorkflowDtoCzechiaWorkflowDto_type;
    salesOrganization?: string;
    externalReference?: string;
    status?: WorkflowStatus;
    tenant?: Country;
    workflowName?: string;
    vehicleTypeShortDescription?: string;
    createdDate?: string;
    createdById?: string;
    modifiedDate?: string;
    modifiedById?: string;
    workflowModifiedDate?: string;
    clientId?: string;
    client?: BusinessPartner;
    quotation?: QuotationDto | undefined;
    purchaseOrders?: PurchaseOrderDto[] | undefined;
    delivery?: DeliveryDto;
    vehicle?: VehicleDto;
    assignees?: Assignee[];
    driverId?: string | undefined;
    replacedCar?: ReplacedCar | undefined;
    notes?: Note[] | undefined;
    eventLogs?: EventLog[];
    etag?: string;

    [key: string]: any;
}

export interface WorkflowDtoFinlandWorkflowDto {
    $type?: WorkflowDtoFinlandWorkflowDto_type;
    contactPersonId?: string | undefined;
    costCenterId?: string | undefined;
    supplierSalesPersonId?: string | undefined;
    openCalculation?: boolean;
    salesOrganization?: string;
    externalReference?: string;
    status?: WorkflowStatus;
    tenant?: Country;
    workflowName?: string;
    vehicleTypeShortDescription?: string;
    createdDate?: string;
    createdById?: string;
    modifiedDate?: string;
    modifiedById?: string;
    workflowModifiedDate?: string;
    clientId?: string;
    client?: BusinessPartner;
    quotation?: QuotationDto | undefined;
    purchaseOrders?: PurchaseOrderDto[] | undefined;
    delivery?: DeliveryDto;
    vehicle?: VehicleDto;
    assignees?: Assignee[];
    driverId?: string | undefined;
    replacedCar?: ReplacedCar | undefined;
    notes?: Note[] | undefined;
    eventLogs?: EventLog[];
    etag?: string;

    [key: string]: any;
}

export interface WorkflowDtoNolsWorkflowDto {
    $type?: WorkflowDtoNolsWorkflowDto_type;
    externalReference?: string;
    status?: WorkflowStatus;
    tenant?: Country;
    workflowName?: string;
    vehicleTypeShortDescription?: string;
    createdDate?: string;
    createdById?: string;
    modifiedDate?: string;
    modifiedById?: string;
    workflowModifiedDate?: string;
    clientId?: string;
    client?: BusinessPartner;
    quotation?: QuotationDto | undefined;
    purchaseOrders?: PurchaseOrderDto[] | undefined;
    delivery?: DeliveryDto;
    vehicle?: VehicleDto;
    assignees?: Assignee[];
    driverId?: string | undefined;
    replacedCar?: ReplacedCar | undefined;
    notes?: Note[] | undefined;
    eventLogs?: EventLog[];
    etag?: string;
    nolsRecordId?: string;

    [key: string]: any;
}

export interface WorkflowDtoWorkflowDto {
    $type?: WorkflowDtoWorkflowDto_type;
    externalReference: string;
    status: WorkflowStatus;
    tenant?: Country;
    workflowName?: string;
    vehicleTypeShortDescription?: string;
    createdDate?: string;
    createdById?: string;
    modifiedDate?: string;
    modifiedById?: string;
    workflowModifiedDate?: string;
    clientId?: string;
    client?: BusinessPartner;
    quotation?: QuotationDto | undefined;
    purchaseOrders?: PurchaseOrderDto[] | undefined;
    delivery?: DeliveryDto;
    vehicle?: VehicleDto;
    assignees?: Assignee[];
    driverId?: string | undefined;
    replacedCar?: ReplacedCar | undefined;
    notes?: Note[] | undefined;
    eventLogs?: EventLog[];
    etag?: string;

    [key: string]: any;
}

export interface WorkflowFlatDto {
    externalReference: string;
    status: WorkflowStatus;
    workflowName?: string;
    vehicleTypeShortDescription?: string;
    createdDate?: string;
    assignees?: AssigneeFlatDto[];
    clientId?: string;
    clientName?: string | undefined;
    quotation?: QuotationFlatDto | undefined;
    purchaseOrders?: PurchaseOrderFlatDto[] | undefined;
    vehicle?: VehicleFlatDto;

    [key: string]: any;
}

export type WorkflowStatus = "NotDefined" | "QuotationApproval" | "OrderApproval" | "OrderProcessing" | "OrderUpdated" | "Delivery" | "QuotationRejected" | "OrderRejected" | "Completed" | "Archived";

export const WorkflowStatusKeys: WorkflowStatus[] = ["NotDefined", "QuotationApproval", "OrderApproval", "OrderProcessing", "OrderUpdated", "Delivery", "QuotationRejected", "OrderRejected", "Completed", "Archived"];
    
export const WorkflowStatus: Record<WorkflowStatus, WorkflowStatus> = {
    "NotDefined": "NotDefined",
    "QuotationApproval": "QuotationApproval",
    "OrderApproval": "OrderApproval",
    "OrderProcessing": "OrderProcessing",
    "OrderUpdated": "OrderUpdated",
    "Delivery": "Delivery",
    "QuotationRejected": "QuotationRejected",
    "OrderRejected": "OrderRejected",
    "Completed": "Completed",
    "Archived": "Archived"
};

export type Statuses = "NotDefined" | "QuotationApproval" | "OrderApproval" | "OrderProcessing" | "OrderUpdated" | "Delivery" | "QuotationRejected" | "OrderRejected" | "Completed" | "Archived";

export const StatusesKeys: Statuses[] = ["NotDefined", "QuotationApproval", "OrderApproval", "OrderProcessing", "OrderUpdated", "Delivery", "QuotationRejected", "OrderRejected", "Completed", "Archived"];
    
export const Statuses: Record<Statuses, Statuses> = {
    "NotDefined": "NotDefined",
    "QuotationApproval": "QuotationApproval",
    "OrderApproval": "OrderApproval",
    "OrderProcessing": "OrderProcessing",
    "OrderUpdated": "OrderUpdated",
    "Delivery": "Delivery",
    "QuotationRejected": "QuotationRejected",
    "OrderRejected": "OrderRejected",
    "Completed": "Completed",
    "Archived": "Archived"
};

export type Steps = "NotDefined" | "SchemaFinalization" | "ClientApproval" | "ClientAccountAcceptation" | "OrderCreation" | "Parked" | "Rejection" | "Rejected" | "Completed" | "DriverApproval" | "HRApproval" | "FleetManagerApproval" | "SupervisorApproval" | "GroupApproval" | "PurchaseSupportApproval" | "PersonApproval" | "NotRegisteredUserApproval" | "KamApproval" | "ODApproval" | "DealerAcceptation" | "DealerConfirmation" | "DealerRejectionConfirmation" | "DealerRejection" | "SupplierApproval" | "SupplierAcceptation" | "DeliveryConfirmation" | "Delivered" | "NotActive" | "Waiting" | "VehicleRegistration" | "HandoverPreparation" | "Handover";

export const StepsKeys: Steps[] = ["NotDefined", "SchemaFinalization", "ClientApproval", "ClientAccountAcceptation", "OrderCreation", "Parked", "Rejection", "Rejected", "Completed", "DriverApproval", "HRApproval", "FleetManagerApproval", "SupervisorApproval", "GroupApproval", "PurchaseSupportApproval", "PersonApproval", "NotRegisteredUserApproval", "KamApproval", "ODApproval", "DealerAcceptation", "DealerConfirmation", "DealerRejectionConfirmation", "DealerRejection", "SupplierApproval", "SupplierAcceptation", "DeliveryConfirmation", "Delivered", "NotActive", "Waiting", "VehicleRegistration", "HandoverPreparation", "Handover"];
    
export const Steps: Record<Steps, Steps> = {
    "NotDefined": "NotDefined",
    "SchemaFinalization": "SchemaFinalization",
    "ClientApproval": "ClientApproval",
    "ClientAccountAcceptation": "ClientAccountAcceptation",
    "OrderCreation": "OrderCreation",
    "Parked": "Parked",
    "Rejection": "Rejection",
    "Rejected": "Rejected",
    "Completed": "Completed",
    "DriverApproval": "DriverApproval",
    "HRApproval": "HRApproval",
    "FleetManagerApproval": "FleetManagerApproval",
    "SupervisorApproval": "SupervisorApproval",
    "GroupApproval": "GroupApproval",
    "PurchaseSupportApproval": "PurchaseSupportApproval",
    "PersonApproval": "PersonApproval",
    "NotRegisteredUserApproval": "NotRegisteredUserApproval",
    "KamApproval": "KamApproval",
    "ODApproval": "ODApproval",
    "DealerAcceptation": "DealerAcceptation",
    "DealerConfirmation": "DealerConfirmation",
    "DealerRejectionConfirmation": "DealerRejectionConfirmation",
    "DealerRejection": "DealerRejection",
    "SupplierApproval": "SupplierApproval",
    "SupplierAcceptation": "SupplierAcceptation",
    "DeliveryConfirmation": "DeliveryConfirmation",
    "Delivered": "Delivered",
    "NotActive": "NotActive",
    "Waiting": "Waiting",
    "VehicleRegistration": "VehicleRegistration",
    "HandoverPreparation": "HandoverPreparation",
    "Handover": "Handover"
};

export type Statuses2 = "NotDefined" | "QuotationApproval" | "OrderApproval" | "OrderProcessing" | "OrderUpdated" | "Delivery" | "QuotationRejected" | "OrderRejected" | "Completed" | "Archived";

export const Statuses2Keys: Statuses2[] = ["NotDefined", "QuotationApproval", "OrderApproval", "OrderProcessing", "OrderUpdated", "Delivery", "QuotationRejected", "OrderRejected", "Completed", "Archived"];
    
export const Statuses2: Record<Statuses2, Statuses2> = {
    "NotDefined": "NotDefined",
    "QuotationApproval": "QuotationApproval",
    "OrderApproval": "OrderApproval",
    "OrderProcessing": "OrderProcessing",
    "OrderUpdated": "OrderUpdated",
    "Delivery": "Delivery",
    "QuotationRejected": "QuotationRejected",
    "OrderRejected": "OrderRejected",
    "Completed": "Completed",
    "Archived": "Archived"
};

export type Steps2 = "NotDefined" | "SchemaFinalization" | "ClientApproval" | "ClientAccountAcceptation" | "OrderCreation" | "Parked" | "Rejection" | "Rejected" | "Completed" | "DriverApproval" | "HRApproval" | "FleetManagerApproval" | "SupervisorApproval" | "GroupApproval" | "PurchaseSupportApproval" | "PersonApproval" | "NotRegisteredUserApproval" | "KamApproval" | "ODApproval" | "DealerAcceptation" | "DealerConfirmation" | "DealerRejectionConfirmation" | "DealerRejection" | "SupplierApproval" | "SupplierAcceptation" | "DeliveryConfirmation" | "Delivered" | "NotActive" | "Waiting" | "VehicleRegistration" | "HandoverPreparation" | "Handover";

export const Steps2Keys: Steps2[] = ["NotDefined", "SchemaFinalization", "ClientApproval", "ClientAccountAcceptation", "OrderCreation", "Parked", "Rejection", "Rejected", "Completed", "DriverApproval", "HRApproval", "FleetManagerApproval", "SupervisorApproval", "GroupApproval", "PurchaseSupportApproval", "PersonApproval", "NotRegisteredUserApproval", "KamApproval", "ODApproval", "DealerAcceptation", "DealerConfirmation", "DealerRejectionConfirmation", "DealerRejection", "SupplierApproval", "SupplierAcceptation", "DeliveryConfirmation", "Delivered", "NotActive", "Waiting", "VehicleRegistration", "HandoverPreparation", "Handover"];
    
export const Steps2: Record<Steps2, Steps2> = {
    "NotDefined": "NotDefined",
    "SchemaFinalization": "SchemaFinalization",
    "ClientApproval": "ClientApproval",
    "ClientAccountAcceptation": "ClientAccountAcceptation",
    "OrderCreation": "OrderCreation",
    "Parked": "Parked",
    "Rejection": "Rejection",
    "Rejected": "Rejected",
    "Completed": "Completed",
    "DriverApproval": "DriverApproval",
    "HRApproval": "HRApproval",
    "FleetManagerApproval": "FleetManagerApproval",
    "SupervisorApproval": "SupervisorApproval",
    "GroupApproval": "GroupApproval",
    "PurchaseSupportApproval": "PurchaseSupportApproval",
    "PersonApproval": "PersonApproval",
    "NotRegisteredUserApproval": "NotRegisteredUserApproval",
    "KamApproval": "KamApproval",
    "ODApproval": "ODApproval",
    "DealerAcceptation": "DealerAcceptation",
    "DealerConfirmation": "DealerConfirmation",
    "DealerRejectionConfirmation": "DealerRejectionConfirmation",
    "DealerRejection": "DealerRejection",
    "SupplierApproval": "SupplierApproval",
    "SupplierAcceptation": "SupplierAcceptation",
    "DeliveryConfirmation": "DeliveryConfirmation",
    "Delivered": "Delivered",
    "NotActive": "NotActive",
    "Waiting": "Waiting",
    "VehicleRegistration": "VehicleRegistration",
    "HandoverPreparation": "HandoverPreparation",
    "Handover": "Handover"
};

export interface Body {
    /** JsonPatchDocument operation */
    op: BodyOp;
    /** Path to property where to execute operation */
    path: string;
    value: any;
    /** Path to property from which to copy from */
    from?: string;

    [key: string]: any;
}

export type Operation = "Added" | "Modified" | "Deleted";

export const OperationKeys: Operation[] = ["Added", "Modified", "Deleted"];
    
export const Operation: Record<Operation, Operation> = {
    "Added": "Added",
    "Modified": "Modified",
    "Deleted": "Deleted"
};

export type AddonNolsAccessory_type = "NolsAccessory";

export const AddonNolsAccessory_typeKeys: AddonNolsAccessory_type[] = ["NolsAccessory"];
    
export const AddonNolsAccessory_type: Record<AddonNolsAccessory_type, AddonNolsAccessory_type> = {
    "NolsAccessory": "NolsAccessory"
};

export type AddonNolsELogBook_type = "NolsELogBook";

export const AddonNolsELogBook_typeKeys: AddonNolsELogBook_type[] = ["NolsELogBook"];
    
export const AddonNolsELogBook_type: Record<AddonNolsELogBook_type, AddonNolsELogBook_type> = {
    "NolsELogBook": "NolsELogBook"
};

export type AddonNolsService_type = "NolsService";

export const AddonNolsService_typeKeys: AddonNolsService_type[] = ["NolsService"];
    
export const AddonNolsService_type: Record<AddonNolsService_type, AddonNolsService_type> = {
    "NolsService": "NolsService"
};

export type AddonNolsWinterTyre_type = "NolsWinterTyre";

export const AddonNolsWinterTyre_typeKeys: AddonNolsWinterTyre_type[] = ["NolsWinterTyre"];
    
export const AddonNolsWinterTyre_type: Record<AddonNolsWinterTyre_type, AddonNolsWinterTyre_type> = {
    "NolsWinterTyre": "NolsWinterTyre"
};

export type AddonPressureSensor_type = "PressureSensor";

export const AddonPressureSensor_typeKeys: AddonPressureSensor_type[] = ["PressureSensor"];
    
export const AddonPressureSensor_type: Record<AddonPressureSensor_type, AddonPressureSensor_type> = {
    "PressureSensor": "PressureSensor"
};

export type AddonRim_type = "Rim";

export const AddonRim_typeKeys: AddonRim_type[] = ["Rim"];
    
export const AddonRim_type: Record<AddonRim_type, AddonRim_type> = {
    "Rim": "Rim"
};

export type AddonSapAccessory_type = "SapAccessory";

export const AddonSapAccessory_typeKeys: AddonSapAccessory_type[] = ["SapAccessory"];
    
export const AddonSapAccessory_type: Record<AddonSapAccessory_type, AddonSapAccessory_type> = {
    "SapAccessory": "SapAccessory"
};

export type AddonSapOption_type = "SapOption";

export const AddonSapOption_typeKeys: AddonSapOption_type[] = ["SapOption"];
    
export const AddonSapOption_type: Record<AddonSapOption_type, AddonSapOption_type> = {
    "SapOption": "SapOption"
};

export type AddonSapService_type = "SapService";

export const AddonSapService_typeKeys: AddonSapService_type[] = ["SapService"];
    
export const AddonSapService_type: Record<AddonSapService_type, AddonSapService_type> = {
    "SapService": "SapService"
};

export type AddonTyre_type = "Tyre";

export const AddonTyre_typeKeys: AddonTyre_type[] = ["Tyre"];
    
export const AddonTyre_type: Record<AddonTyre_type, AddonTyre_type> = {
    "Tyre": "Tyre"
};

export type ApprovalStepDriverApprovalStep_type = "DriverApprovalStep";

export const ApprovalStepDriverApprovalStep_typeKeys: ApprovalStepDriverApprovalStep_type[] = ["DriverApprovalStep"];
    
export const ApprovalStepDriverApprovalStep_type: Record<ApprovalStepDriverApprovalStep_type, ApprovalStepDriverApprovalStep_type> = {
    "DriverApprovalStep": "DriverApprovalStep"
};

export type ApprovalStepFleetManagerApprovalStep_type = "FleetManagerApprovalStep";

export const ApprovalStepFleetManagerApprovalStep_typeKeys: ApprovalStepFleetManagerApprovalStep_type[] = ["FleetManagerApprovalStep"];
    
export const ApprovalStepFleetManagerApprovalStep_type: Record<ApprovalStepFleetManagerApprovalStep_type, ApprovalStepFleetManagerApprovalStep_type> = {
    "FleetManagerApprovalStep": "FleetManagerApprovalStep"
};

export type ApprovalStepGroupApprovalStep_type = "GroupApprovalStep";

export const ApprovalStepGroupApprovalStep_typeKeys: ApprovalStepGroupApprovalStep_type[] = ["GroupApprovalStep"];
    
export const ApprovalStepGroupApprovalStep_type: Record<ApprovalStepGroupApprovalStep_type, ApprovalStepGroupApprovalStep_type> = {
    "GroupApprovalStep": "GroupApprovalStep"
};

export type ApprovalStepHrApprovalStep_type = "HrApprovalStep";

export const ApprovalStepHrApprovalStep_typeKeys: ApprovalStepHrApprovalStep_type[] = ["HrApprovalStep"];
    
export const ApprovalStepHrApprovalStep_type: Record<ApprovalStepHrApprovalStep_type, ApprovalStepHrApprovalStep_type> = {
    "HrApprovalStep": "HrApprovalStep"
};

export type ApprovalStepNotRegisteredUserApprovalStep_type = "NotRegisteredUserApprovalStep";

export const ApprovalStepNotRegisteredUserApprovalStep_typeKeys: ApprovalStepNotRegisteredUserApprovalStep_type[] = ["NotRegisteredUserApprovalStep"];
    
export const ApprovalStepNotRegisteredUserApprovalStep_type: Record<ApprovalStepNotRegisteredUserApprovalStep_type, ApprovalStepNotRegisteredUserApprovalStep_type> = {
    "NotRegisteredUserApprovalStep": "NotRegisteredUserApprovalStep"
};

export type ApprovalStepPersonApprovalStep_type = "PersonApprovalStep";

export const ApprovalStepPersonApprovalStep_typeKeys: ApprovalStepPersonApprovalStep_type[] = ["PersonApprovalStep"];
    
export const ApprovalStepPersonApprovalStep_type: Record<ApprovalStepPersonApprovalStep_type, ApprovalStepPersonApprovalStep_type> = {
    "PersonApprovalStep": "PersonApprovalStep"
};

export type ApprovalStepPurchaseSupportApprovalStep_type = "PurchaseSupportApprovalStep";

export const ApprovalStepPurchaseSupportApprovalStep_typeKeys: ApprovalStepPurchaseSupportApprovalStep_type[] = ["PurchaseSupportApprovalStep"];
    
export const ApprovalStepPurchaseSupportApprovalStep_type: Record<ApprovalStepPurchaseSupportApprovalStep_type, ApprovalStepPurchaseSupportApprovalStep_type> = {
    "PurchaseSupportApprovalStep": "PurchaseSupportApprovalStep"
};

export type ApprovalStepSupervisorApprovalStep_type = "SupervisorApprovalStep";

export const ApprovalStepSupervisorApprovalStep_typeKeys: ApprovalStepSupervisorApprovalStep_type[] = ["SupervisorApprovalStep"];
    
export const ApprovalStepSupervisorApprovalStep_type: Record<ApprovalStepSupervisorApprovalStep_type, ApprovalStepSupervisorApprovalStep_type> = {
    "SupervisorApprovalStep": "SupervisorApprovalStep"
};

export type AssigneeFlatDtoGroupAssigneeFlatDto_type = "GroupAssignee";

export const AssigneeFlatDtoGroupAssigneeFlatDto_typeKeys: AssigneeFlatDtoGroupAssigneeFlatDto_type[] = ["GroupAssignee"];
    
export const AssigneeFlatDtoGroupAssigneeFlatDto_type: Record<AssigneeFlatDtoGroupAssigneeFlatDto_type, AssigneeFlatDtoGroupAssigneeFlatDto_type> = {
    "GroupAssignee": "GroupAssignee"
};

export type AssigneeFlatDtoNotRegisteredAssigneeFlatDto_type = "NotRegisteredAssignee";

export const AssigneeFlatDtoNotRegisteredAssigneeFlatDto_typeKeys: AssigneeFlatDtoNotRegisteredAssigneeFlatDto_type[] = ["NotRegisteredAssignee"];
    
export const AssigneeFlatDtoNotRegisteredAssigneeFlatDto_type: Record<AssigneeFlatDtoNotRegisteredAssigneeFlatDto_type, AssigneeFlatDtoNotRegisteredAssigneeFlatDto_type> = {
    "NotRegisteredAssignee": "NotRegisteredAssignee"
};

export type AssigneeFlatDtoPersonAssigneeFlatDto_type = "PersonAssignee";

export const AssigneeFlatDtoPersonAssigneeFlatDto_typeKeys: AssigneeFlatDtoPersonAssigneeFlatDto_type[] = ["PersonAssignee"];
    
export const AssigneeFlatDtoPersonAssigneeFlatDto_type: Record<AssigneeFlatDtoPersonAssigneeFlatDto_type, AssigneeFlatDtoPersonAssigneeFlatDto_type> = {
    "PersonAssignee": "PersonAssignee"
};

export type AssigneeFlatDtoRoleAssigneeFlatDto_type = "RoleAssignee";

export const AssigneeFlatDtoRoleAssigneeFlatDto_typeKeys: AssigneeFlatDtoRoleAssigneeFlatDto_type[] = ["RoleAssignee"];
    
export const AssigneeFlatDtoRoleAssigneeFlatDto_type: Record<AssigneeFlatDtoRoleAssigneeFlatDto_type, AssigneeFlatDtoRoleAssigneeFlatDto_type> = {
    "RoleAssignee": "RoleAssignee"
};

export type AssigneeGroupAssignee_type = "GroupAssignee";

export const AssigneeGroupAssignee_typeKeys: AssigneeGroupAssignee_type[] = ["GroupAssignee"];
    
export const AssigneeGroupAssignee_type: Record<AssigneeGroupAssignee_type, AssigneeGroupAssignee_type> = {
    "GroupAssignee": "GroupAssignee"
};

export type AssigneeNotRegisteredAssignee_type = "NotRegisteredAssignee";

export const AssigneeNotRegisteredAssignee_typeKeys: AssigneeNotRegisteredAssignee_type[] = ["NotRegisteredAssignee"];
    
export const AssigneeNotRegisteredAssignee_type: Record<AssigneeNotRegisteredAssignee_type, AssigneeNotRegisteredAssignee_type> = {
    "NotRegisteredAssignee": "NotRegisteredAssignee"
};

export type AssigneePersonAssignee_type = "PersonAssignee";

export const AssigneePersonAssignee_typeKeys: AssigneePersonAssignee_type[] = ["PersonAssignee"];
    
export const AssigneePersonAssignee_type: Record<AssigneePersonAssignee_type, AssigneePersonAssignee_type> = {
    "PersonAssignee": "PersonAssignee"
};

export type AssigneeRoleAssignee_type = "RoleAssignee";

export const AssigneeRoleAssignee_typeKeys: AssigneeRoleAssignee_type[] = ["RoleAssignee"];
    
export const AssigneeRoleAssignee_type: Record<AssigneeRoleAssignee_type, AssigneeRoleAssignee_type> = {
    "RoleAssignee": "RoleAssignee"
};

export type AuditEntryDtoAuditEntryDto_type = "AuditEntryDto";

export const AuditEntryDtoAuditEntryDto_typeKeys: AuditEntryDtoAuditEntryDto_type[] = ["AuditEntryDto"];
    
export const AuditEntryDtoAuditEntryDto_type: Record<AuditEntryDtoAuditEntryDto_type, AuditEntryDtoAuditEntryDto_type> = {
    "AuditEntryDto": "AuditEntryDto"
};

export type AuditEntryDtoWorkflowEntityAuditEntryDto_type = "WorkflowEntityAuditEntryDto";

export const AuditEntryDtoWorkflowEntityAuditEntryDto_typeKeys: AuditEntryDtoWorkflowEntityAuditEntryDto_type[] = ["WorkflowEntityAuditEntryDto"];
    
export const AuditEntryDtoWorkflowEntityAuditEntryDto_type: Record<AuditEntryDtoWorkflowEntityAuditEntryDto_type, AuditEntryDtoWorkflowEntityAuditEntryDto_type> = {
    "WorkflowEntityAuditEntryDto": "WorkflowEntityAuditEntryDto"
};

export type BusinessPartnerBusinessPartner_sourceSystem = "Base";

export const BusinessPartnerBusinessPartner_sourceSystemKeys: BusinessPartnerBusinessPartner_sourceSystem[] = ["Base"];
    
export const BusinessPartnerBusinessPartner_sourceSystem: Record<BusinessPartnerBusinessPartner_sourceSystem, BusinessPartnerBusinessPartner_sourceSystem> = {
    "Base": "Base"
};

export type BusinessPartnerNolsBusinessPartner_sourceSystem = "Nols";

export const BusinessPartnerNolsBusinessPartner_sourceSystemKeys: BusinessPartnerNolsBusinessPartner_sourceSystem[] = ["Nols"];
    
export const BusinessPartnerNolsBusinessPartner_sourceSystem: Record<BusinessPartnerNolsBusinessPartner_sourceSystem, BusinessPartnerNolsBusinessPartner_sourceSystem> = {
    "Nols": "Nols"
};

export type BusinessPartnerSapBusinessPartner_sourceSystem = "SAP";

export const BusinessPartnerSapBusinessPartner_sourceSystemKeys: BusinessPartnerSapBusinessPartner_sourceSystem[] = ["SAP"];
    
export const BusinessPartnerSapBusinessPartner_sourceSystem: Record<BusinessPartnerSapBusinessPartner_sourceSystem, BusinessPartnerSapBusinessPartner_sourceSystem> = {
    "SAP": "SAP"
};

export type DeliveryDtoCzechiaDeliveryDto_type = "CzechiaDeliveryDto";

export const DeliveryDtoCzechiaDeliveryDto_typeKeys: DeliveryDtoCzechiaDeliveryDto_type[] = ["CzechiaDeliveryDto"];
    
export const DeliveryDtoCzechiaDeliveryDto_type: Record<DeliveryDtoCzechiaDeliveryDto_type, DeliveryDtoCzechiaDeliveryDto_type> = {
    "CzechiaDeliveryDto": "CzechiaDeliveryDto"
};

export type DeliveryDtoFinlandDeliveryDto_type = "FinlandDeliveryDto";

export const DeliveryDtoFinlandDeliveryDto_typeKeys: DeliveryDtoFinlandDeliveryDto_type[] = ["FinlandDeliveryDto"];
    
export const DeliveryDtoFinlandDeliveryDto_type: Record<DeliveryDtoFinlandDeliveryDto_type, DeliveryDtoFinlandDeliveryDto_type> = {
    "FinlandDeliveryDto": "FinlandDeliveryDto"
};

export type DeliveryDtoNolsDeliveryDto_type = "NolsDeliveryDto";

export const DeliveryDtoNolsDeliveryDto_typeKeys: DeliveryDtoNolsDeliveryDto_type[] = ["NolsDeliveryDto"];
    
export const DeliveryDtoNolsDeliveryDto_type: Record<DeliveryDtoNolsDeliveryDto_type, DeliveryDtoNolsDeliveryDto_type> = {
    "NolsDeliveryDto": "NolsDeliveryDto"
};

export type DriverDtoDriverDto_type = "DriverDto";

export const DriverDtoDriverDto_typeKeys: DriverDtoDriverDto_type[] = ["DriverDto"];
    
export const DriverDtoDriverDto_type: Record<DriverDtoDriverDto_type, DriverDtoDriverDto_type> = {
    "DriverDto": "DriverDto"
};

export type DriverDtoDriverSsnDto_type = "DriverSsnDto";

export const DriverDtoDriverSsnDto_typeKeys: DriverDtoDriverSsnDto_type[] = ["DriverSsnDto"];
    
export const DriverDtoDriverSsnDto_type: Record<DriverDtoDriverSsnDto_type, DriverDtoDriverSsnDto_type> = {
    "DriverSsnDto": "DriverSsnDto"
};

export type OrganizationPartnerDtoCostCenterDto_type = "CostCenterDto";

export const OrganizationPartnerDtoCostCenterDto_typeKeys: OrganizationPartnerDtoCostCenterDto_type[] = ["CostCenterDto"];
    
export const OrganizationPartnerDtoCostCenterDto_type: Record<OrganizationPartnerDtoCostCenterDto_type, OrganizationPartnerDtoCostCenterDto_type> = {
    "CostCenterDto": "CostCenterDto"
};

export type OrganizationPartnerDtoOrganizationPartnerDto_type = "OrganizationPartnerDto";

export const OrganizationPartnerDtoOrganizationPartnerDto_typeKeys: OrganizationPartnerDtoOrganizationPartnerDto_type[] = ["OrganizationPartnerDto"];
    
export const OrganizationPartnerDtoOrganizationPartnerDto_type: Record<OrganizationPartnerDtoOrganizationPartnerDto_type, OrganizationPartnerDtoOrganizationPartnerDto_type> = {
    "OrganizationPartnerDto": "OrganizationPartnerDto"
};

export type OrganizationPartnerDtoSupplierPartnerDto_type = "SupplierPartnerDto";

export const OrganizationPartnerDtoSupplierPartnerDto_typeKeys: OrganizationPartnerDtoSupplierPartnerDto_type[] = ["SupplierPartnerDto"];
    
export const OrganizationPartnerDtoSupplierPartnerDto_type: Record<OrganizationPartnerDtoSupplierPartnerDto_type, OrganizationPartnerDtoSupplierPartnerDto_type> = {
    "SupplierPartnerDto": "SupplierPartnerDto"
};

export type PurchaseOrderAddonDtoPurchaseOrderAccessoryDto_type = "PurchaseOrderAccessoryDto";

export const PurchaseOrderAddonDtoPurchaseOrderAccessoryDto_typeKeys: PurchaseOrderAddonDtoPurchaseOrderAccessoryDto_type[] = ["PurchaseOrderAccessoryDto"];
    
export const PurchaseOrderAddonDtoPurchaseOrderAccessoryDto_type: Record<PurchaseOrderAddonDtoPurchaseOrderAccessoryDto_type, PurchaseOrderAddonDtoPurchaseOrderAccessoryDto_type> = {
    "PurchaseOrderAccessoryDto": "PurchaseOrderAccessoryDto"
};

export type PurchaseOrderAddonDtoPurchaseOrderOptionDto_type = "PurchaseOrderOptionDto";

export const PurchaseOrderAddonDtoPurchaseOrderOptionDto_typeKeys: PurchaseOrderAddonDtoPurchaseOrderOptionDto_type[] = ["PurchaseOrderOptionDto"];
    
export const PurchaseOrderAddonDtoPurchaseOrderOptionDto_type: Record<PurchaseOrderAddonDtoPurchaseOrderOptionDto_type, PurchaseOrderAddonDtoPurchaseOrderOptionDto_type> = {
    "PurchaseOrderOptionDto": "PurchaseOrderOptionDto"
};

export type PurchaseOrderAddonDtoPurchaseOrderTyreDto_type = "PurchaseOrderTyreDto";

export const PurchaseOrderAddonDtoPurchaseOrderTyreDto_typeKeys: PurchaseOrderAddonDtoPurchaseOrderTyreDto_type[] = ["PurchaseOrderTyreDto"];
    
export const PurchaseOrderAddonDtoPurchaseOrderTyreDto_type: Record<PurchaseOrderAddonDtoPurchaseOrderTyreDto_type, PurchaseOrderAddonDtoPurchaseOrderTyreDto_type> = {
    "PurchaseOrderTyreDto": "PurchaseOrderTyreDto"
};

export type PurchaseOrderDtoCzechiaVehicleOrderDto_type = "CzechiaVehicleOrderDto";

export const PurchaseOrderDtoCzechiaVehicleOrderDto_typeKeys: PurchaseOrderDtoCzechiaVehicleOrderDto_type[] = ["CzechiaVehicleOrderDto"];
    
export const PurchaseOrderDtoCzechiaVehicleOrderDto_type: Record<PurchaseOrderDtoCzechiaVehicleOrderDto_type, PurchaseOrderDtoCzechiaVehicleOrderDto_type> = {
    "CzechiaVehicleOrderDto": "CzechiaVehicleOrderDto"
};

export type PurchaseOrderDtoFinlandVehicleOrderDto_type = "FinlandVehicleOrderDto";

export const PurchaseOrderDtoFinlandVehicleOrderDto_typeKeys: PurchaseOrderDtoFinlandVehicleOrderDto_type[] = ["FinlandVehicleOrderDto"];
    
export const PurchaseOrderDtoFinlandVehicleOrderDto_type: Record<PurchaseOrderDtoFinlandVehicleOrderDto_type, PurchaseOrderDtoFinlandVehicleOrderDto_type> = {
    "FinlandVehicleOrderDto": "FinlandVehicleOrderDto"
};

export type PurchaseOrderDtoNolsOrderDto_type = "NolsOrderDto";

export const PurchaseOrderDtoNolsOrderDto_typeKeys: PurchaseOrderDtoNolsOrderDto_type[] = ["NolsOrderDto"];
    
export const PurchaseOrderDtoNolsOrderDto_type: Record<PurchaseOrderDtoNolsOrderDto_type, PurchaseOrderDtoNolsOrderDto_type> = {
    "NolsOrderDto": "NolsOrderDto"
};

export type PurchaseOrderDtoTyreOrderDto_type = "TyreOrderDto";

export const PurchaseOrderDtoTyreOrderDto_typeKeys: PurchaseOrderDtoTyreOrderDto_type[] = ["TyreOrderDto"];
    
export const PurchaseOrderDtoTyreOrderDto_type: Record<PurchaseOrderDtoTyreOrderDto_type, PurchaseOrderDtoTyreOrderDto_type> = {
    "TyreOrderDto": "TyreOrderDto"
};

export type PurchaseOrderFlatDtoTyreOrderFlatDto_type = "TyreOrderFlatDto";

export const PurchaseOrderFlatDtoTyreOrderFlatDto_typeKeys: PurchaseOrderFlatDtoTyreOrderFlatDto_type[] = ["TyreOrderFlatDto"];
    
export const PurchaseOrderFlatDtoTyreOrderFlatDto_type: Record<PurchaseOrderFlatDtoTyreOrderFlatDto_type, PurchaseOrderFlatDtoTyreOrderFlatDto_type> = {
    "TyreOrderFlatDto": "TyreOrderFlatDto"
};

export type PurchaseOrderFlatDtoVehicleOrderFlatDto_type = "VehicleOrderFlatDto";

export const PurchaseOrderFlatDtoVehicleOrderFlatDto_typeKeys: PurchaseOrderFlatDtoVehicleOrderFlatDto_type[] = ["VehicleOrderFlatDto"];
    
export const PurchaseOrderFlatDtoVehicleOrderFlatDto_type: Record<PurchaseOrderFlatDtoVehicleOrderFlatDto_type, PurchaseOrderFlatDtoVehicleOrderFlatDto_type> = {
    "VehicleOrderFlatDto": "VehicleOrderFlatDto"
};

export type QuotationDtoCzechiaQuotationDto_type = "CzechiaQuotationDto";

export const QuotationDtoCzechiaQuotationDto_typeKeys: QuotationDtoCzechiaQuotationDto_type[] = ["CzechiaQuotationDto"];
    
export const QuotationDtoCzechiaQuotationDto_type: Record<QuotationDtoCzechiaQuotationDto_type, QuotationDtoCzechiaQuotationDto_type> = {
    "CzechiaQuotationDto": "CzechiaQuotationDto"
};

export type QuotationDtoFinlandQuotationDto_type = "FinlandQuotationDto";

export const QuotationDtoFinlandQuotationDto_typeKeys: QuotationDtoFinlandQuotationDto_type[] = ["FinlandQuotationDto"];
    
export const QuotationDtoFinlandQuotationDto_type: Record<QuotationDtoFinlandQuotationDto_type, QuotationDtoFinlandQuotationDto_type> = {
    "FinlandQuotationDto": "FinlandQuotationDto"
};

export type QuotationDtoNolsQuotationDto_type = "NolsQuotationDto";

export const QuotationDtoNolsQuotationDto_typeKeys: QuotationDtoNolsQuotationDto_type[] = ["NolsQuotationDto"];
    
export const QuotationDtoNolsQuotationDto_type: Record<QuotationDtoNolsQuotationDto_type, QuotationDtoNolsQuotationDto_type> = {
    "NolsQuotationDto": "NolsQuotationDto"
};

export type RequestedDeliveryDateScenarioDeliveryAfterDate_type = "DeliveryAfterDate";

export const RequestedDeliveryDateScenarioDeliveryAfterDate_typeKeys: RequestedDeliveryDateScenarioDeliveryAfterDate_type[] = ["DeliveryAfterDate"];
    
export const RequestedDeliveryDateScenarioDeliveryAfterDate_type: Record<RequestedDeliveryDateScenarioDeliveryAfterDate_type, RequestedDeliveryDateScenarioDeliveryAfterDate_type> = {
    "DeliveryAfterDate": "DeliveryAfterDate"
};

export type RequestedDeliveryDateScenarioDeliveryASAP_type = "DeliveryASAP";

export const RequestedDeliveryDateScenarioDeliveryASAP_typeKeys: RequestedDeliveryDateScenarioDeliveryASAP_type[] = ["DeliveryASAP"];
    
export const RequestedDeliveryDateScenarioDeliveryASAP_type: Record<RequestedDeliveryDateScenarioDeliveryASAP_type, RequestedDeliveryDateScenarioDeliveryASAP_type> = {
    "DeliveryASAP": "DeliveryASAP"
};

export type RequestedDeliveryDateScenarioDeliveryBeforeDate_type = "DeliveryBeforeDate";

export const RequestedDeliveryDateScenarioDeliveryBeforeDate_typeKeys: RequestedDeliveryDateScenarioDeliveryBeforeDate_type[] = ["DeliveryBeforeDate"];
    
export const RequestedDeliveryDateScenarioDeliveryBeforeDate_type: Record<RequestedDeliveryDateScenarioDeliveryBeforeDate_type, RequestedDeliveryDateScenarioDeliveryBeforeDate_type> = {
    "DeliveryBeforeDate": "DeliveryBeforeDate"
};

export type RequestedDeliveryDateScenarioDeliveryOnDate_type = "DeliveryOnDate";

export const RequestedDeliveryDateScenarioDeliveryOnDate_typeKeys: RequestedDeliveryDateScenarioDeliveryOnDate_type[] = ["DeliveryOnDate"];
    
export const RequestedDeliveryDateScenarioDeliveryOnDate_type: Record<RequestedDeliveryDateScenarioDeliveryOnDate_type, RequestedDeliveryDateScenarioDeliveryOnDate_type> = {
    "DeliveryOnDate": "DeliveryOnDate"
};

export type WorkflowDtoCzechiaWorkflowDto_type = "CzechiaWorkflowDto";

export const WorkflowDtoCzechiaWorkflowDto_typeKeys: WorkflowDtoCzechiaWorkflowDto_type[] = ["CzechiaWorkflowDto"];
    
export const WorkflowDtoCzechiaWorkflowDto_type: Record<WorkflowDtoCzechiaWorkflowDto_type, WorkflowDtoCzechiaWorkflowDto_type> = {
    "CzechiaWorkflowDto": "CzechiaWorkflowDto"
};

export type WorkflowDtoFinlandWorkflowDto_type = "FinlandWorkflowDto";

export const WorkflowDtoFinlandWorkflowDto_typeKeys: WorkflowDtoFinlandWorkflowDto_type[] = ["FinlandWorkflowDto"];
    
export const WorkflowDtoFinlandWorkflowDto_type: Record<WorkflowDtoFinlandWorkflowDto_type, WorkflowDtoFinlandWorkflowDto_type> = {
    "FinlandWorkflowDto": "FinlandWorkflowDto"
};

export type WorkflowDtoNolsWorkflowDto_type = "NolsWorkflowDto";

export const WorkflowDtoNolsWorkflowDto_typeKeys: WorkflowDtoNolsWorkflowDto_type[] = ["NolsWorkflowDto"];
    
export const WorkflowDtoNolsWorkflowDto_type: Record<WorkflowDtoNolsWorkflowDto_type, WorkflowDtoNolsWorkflowDto_type> = {
    "NolsWorkflowDto": "NolsWorkflowDto"
};

export type WorkflowDtoWorkflowDto_type = "WorkflowDto";

export const WorkflowDtoWorkflowDto_typeKeys: WorkflowDtoWorkflowDto_type[] = ["WorkflowDto"];
    
export const WorkflowDtoWorkflowDto_type: Record<WorkflowDtoWorkflowDto_type, WorkflowDtoWorkflowDto_type> = {
    "WorkflowDto": "WorkflowDto"
};

export type BodyOp = "add" | "replace";

export const BodyOpKeys: BodyOp[] = ["add", "replace"];
    
export const BodyOp: Record<BodyOp, BodyOp> = {
    "add": "add",
    "replace": "replace"
};

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;
}

function mapHeaders(headers: AxiosResponse['headers']): { [key: string]: any } {
  let _headers: any = {};
  if (headers && typeof headers === 'object') {
    for (let k in headers) {
      if (headers.hasOwnProperty(k)) {
        _headers[k] = headers[k];
      }
    }
  }

  return _headers;
}

function throwException(
  message: string,
  status: number,
  headers: { [key: string]: any },
  result?: any
): never {
  throw new ApiException(message, status, headers, result);
}

export function isApiException(value: any): value is ApiException {
  return value.isApiException === true;
}

const apiApiResultSuccessType = 'success';
const apiApiResultAcceptedType = 'accepted';
const apiApiResultHandledErrorType = 'handledError';
const apiApiResultCustomErrorType = 'customError';

/** Result type for 202 Accepted responses (async processing started, no data yet) */
export type ApiAcceptedResult = {
  type: typeof apiApiResultAcceptedType;
  /** Raw Axios response */
  response: AxiosResponse;
};

export type ApiResult<TSuccess, TError> =
  | {
      /** The type of result. Use this to discriminate the union (get success or error fields)
       * @example
       * Success example:
       * ```
       * const resp = await getWhatever(123);
       * if (resp.type === 'success') {
       *  console.info(resp.data);
       *} else if (resp.handledCode === 'apiDown') {
       *  console.warn('api is down :(', resp.error);
       *}
       * ```
       * @example
       * Custom error example:
       * ```
       * const resp = await getWhatever(123);
       * if (resp.type === 'success') {
       *  console.info(resp.data);
       *  } else if (resp.type === 'customError') {
       *  console.warn(resp.data);
       *}
       * ```
       * @example
       * Accepted (202) example:
       * ```
       * const resp = await startAsyncProcess(123);
       * if (resp.type === 'accepted') {
       *  console.info('Processing started');
       *}
       * ```
       */
      type: typeof apiApiResultSuccessType;
      /** Raw Axios response */
      response: AxiosResponse<TSuccess>;
      /** Success data */
      data: TSuccess;
    }
  | ApiAcceptedResult
  | ApiErrorResult<TError>;

export type ApiNoDataResult<TError> =
  | {
      /** The type of result. Use this to discriminate the union (get success or error fields)
       * @example
       * Success example:
       * ```
       * const resp = await getWhatever(123);
       * if (resp.type === 'success') {
       *  console.info(resp.data);
       *} else if (resp.handledCode === 'apiDown') {
       *  console.warn('api is down :(', resp.error);
       *}
       * ```
       * @example
       * Custom error example:
       * ```
       * const resp = await getWhatever(123);
       * if (resp.type === 'success') {
       *  console.info(resp.data);
       *  } else if (resp.type === 'customError') {
       *  console.warn(resp.data);
       *}
       * ```
       */
      type: 'success';
      /** Raw Axios response */
      response: AxiosResponse;
    }
  | ApiAcceptedResult
  | ApiErrorResult<TError>;

type ApiErrorResult<T> =
  | ({
      type: typeof apiApiResultHandledErrorType;
    } & (
      | {
          /** The handled code */
          handledCode: 400 | 401 | 403 | 404 | 409 | 429;
          /** The raw Axios response */
          response: AxiosResponse;
        }
      | {
          /** The handled code */
          handledCode: 'apiDown';
          /** The raw Axios response */
          error: AxiosError;
        }
    ))
  | (T extends void
      ? never
      : {
          type: typeof apiApiResultCustomErrorType;
          /** Custom error data */
          data: T;
          /** The raw Axios response */
          response: AxiosResponse<T>;
        });

export type ApiResultPromise<
  TSuccess = unknown,
  TError = unknown
> = PromiseLike<ApiResult<TSuccess, TError> | ApiNoDataResult<TError>>;

export function isApiResult(
  value: any
): value is ApiResult<unknown, unknown> | ApiNoDataResult<unknown> {
  return (
    value &&
    [
      apiApiResultSuccessType,
      apiApiResultAcceptedType,
      apiApiResultHandledErrorType,
      apiApiResultCustomErrorType,
    ].includes(value.type)
  );
}

/**
 * Unwrap the result if you don't need to handle the error case and getting an undefined is OK
 * @param result The response result
 * @returns The success data if the call succeeded, undefined otherwise
 */
export function unwrapResult<TSuccess>(
  result: ApiResult<TSuccess, any>
): TSuccess | undefined {
  return result.type === 'success' ? result.data : undefined;
}

/**
 * Unwrap the result if you don't need to handle the error case and getting a default value is OK
 * @param result The response result
 * @param fallback The fallback value
 * @returns The success data if the call succeeded, the fallback otherwise
 */
export function unwrapResultOr<TSuccess>(
  result: ApiResult<TSuccess, any>,
  fallback: TSuccess
): TSuccess {
  return result.type === 'success' ? result.data : fallback;
}

type ResponseHandler<T = AxiosResponse> =
  | ((response: T) => void)
  | string
  | false;
interface ResponseHandlers {
  /** Custom not found (404) handler.

  Set to a string to change the default notification text.

  Set to false to skip handling of this code which will throw and can be handled in a catch block instead. */
  notFoundHandler?: ResponseHandler;
  /** Custom forbidden (403) handler.

  Set to a string to change the default notification text.

  Set to false to skip handling of this code which will throw and can be handled in a catch block instead. */
  forbiddenHandler?: ResponseHandler;
  /** Custom unauthenticated (401) handler.

  Set to a string to change the default notification text.

  Set to false to skip handling of this code which will throw and can be handled in a catch block instead. */
  unauthenticatedHandler?: ResponseHandler;
  /** Custom conflict (409) handler.

  Set to a string to change the default notification text.

  Set to false to skip handling of this code which will throw and can be handled in a catch block instead. */
  conflictHandler?: ResponseHandler;
  /** Custom bad request (400) handler.

  Set to a string to change the default notification text.

  Set to false to skip handling of this code which will throw and can be handled in a catch block instead. */
  badRequestHandler?: ResponseHandler;
  /** Custom rate limited (429) handler.

  Set to a string to change the default notification text.

  Set to false to skip handling of this code which will throw and can be handled in a catch block instead. */
  rateLimitedHandler?: ResponseHandler;
  /** Custom API down handler.

  Set to a string to change the default notification text.

  Set to false to skip handling of this error which will throw and can be handled in a catch block instead. */
  apiDownHandler?: ResponseHandler<AxiosError>;
  /** Skip all default handlers. All non-success will throw and can be handled in a catch block instead */
  disableDefaultErrorHandlers?: boolean;
}

type AdditionalResponseConfiguration = ResponseHandlers & {
  successNotificationMessage?: string;
};

function invokeErrorHandler(
  handlerOrMessage: ResponseHandler<any> | undefined,
  errorResponse: AxiosResponse | AxiosError,
  defaultNotification: string
): ApiErrorResult<void> {
  // todo: replace by own component or at least type it properly
  const toast = useToast();
  if (handlerOrMessage !== undefined) {
    if (handlerOrMessage === false) {
      if (isAxiosError(errorResponse)) {
        throw errorResponse;
      } else {
        throwException(
          `An error occurred and he default handler for code ${errorResponse.status} is disabled`,
          errorResponse.status,
          mapHeaders(errorResponse.headers),
          errorResponse.data
        );
      }
    } else if (typeof handlerOrMessage === 'function') {
      handlerOrMessage(errorResponse);
    } else {
      toast.add({
        title: handlerOrMessage,
        color: 'error',
      });
    }
  } else {
    toast.add({
      title: defaultNotification,
      color: 'error',
    });
  }

  return isAxiosError(errorResponse)
    ? {
        type: 'handledError',
        handledCode: 'apiDown',
        error: errorResponse,
      }
    : {
        type: 'handledError',
        handledCode: errorResponse.status as any,
        response: errorResponse,
      };
}